// @ts-nocheck
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { toastError, presentMutationError } from "../../../utils/showApiErrorToast";
import { parseReportUserError } from "../../../utils/apiErrorDisplay";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Badge as ChakraBadge,
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { toast } from "sonner";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useShadcnInsetDynamicPageTitle } from "@/hooks/useShadcnInsetBreadcrumbTrail";
import {
  WORKSPACE_HUB_BREADCRUMB,
  WORKSPACE_HUB_PATH,
} from "../Workspace/workspaceRoutes";
import { useShadcnInsetChrome } from "@/contexts/ShadcnInsetChromeContext";
import { useShadcnInsetHeaderActions } from "@/contexts/ShadcnInsetHeaderActionsContext";
import { useUserNotificationTimezone } from "../../../hooks/useUserNotificationTimezone";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import CardHeader from "../../../components/Card/CardHeader";
import {
  deleteReport,
  getReport,
  getReportStrategyDetail,
  getReportStrategyPolicyVersionPineScript,
  ReportStrategyPineCompileError,
  updateReport,
} from "../../../services/reportsApi";
import { fetchReportPolicySimConfig } from "../../../services/tradePolicyApi";
import { getBacktestTradeIds, listBacktests, dedupeBacktestsById } from "../../../services/backtestsApi";
import { isTradeManagementBacktest } from "../../../utils/backtestSimulationOverlay";
import { timezoneFromBacktestRow } from "../../../utils/backtestTimezone";
import { Report } from "../../../types/reports";
import type { Backtest } from "../../../types/backtests";
import { ReportTradeReviewPanel } from "./ReportTradeReviewPanel";
import { useMarketCohortPreview } from "./useMarketCohortPreview";
import {
  ReportMarketCohortPreviewCard,
  upsertCohortOverlayStats,
} from "./components/ReportMarketCohortPreviewCard";
import type { CohortPreviewStats } from "../../../utils/cohortTradesResolve";
import { buildExplorerSliceId } from "../../../utils/managementExplorer";
import { exitPlacementSliceDisplayLabel } from "../../../utils/exitPlacementDisplay";
import type { ManagementExplorerSliceRow } from "../../../types/managementExplorer";
import { ReportTradingPnlSection } from "./components/ReportTradingPnlSection";
import { ReportComparisonTradeReviewStack } from "./components/ReportComparisonTradeReviewStack";
import {
  InstrumentSetupGate,
  useInstrumentSetupGateStatus,
} from "../../../components/Instruments/InstrumentSetupGate";
import { useActiveBrokerAccount } from "../../../hooks/useActiveBrokerAccount";
import { shouldBlockSimulator } from "../../../utils/instrumentSetupGate";
import { fetchTrades } from "../../../services/tradeApi";
import { backendTradeToFrontendTrade } from "../../../services/tradeStorage";
import {
  endOfIanaCalendarDayUtc,
  formatDateAsCalendarDayInTimeZone,
} from "../../../utils/notificationPeriod";
import { resolveReportTradeReviewFetchWindow } from "../../../utils/reportTradeReviewWindow";
import { Trade, type DateRange } from "../../../types/trade";
import { filterTradesExitedOnOrBefore } from "../../../utils/reportTradingPnlSeries";
import { enrichNarrativeSessionReferences } from "../../../utils/reportNarrativeEnrichment";
import {
  backendTradeStatisticsToFrontend,
  extractReportWindowTradeStatistics,
} from "../../../utils/extractReportWindowTradeStatistics";
import {
  getReportCandleTimeframeForDisplay,
  getReportCohortWindowLabel,
} from "../../../utils/reportListDisplay";
import {
  formatIanaTimezoneWithUtcOffset,
  getReportDisplayTitle,
  getReportRunTimezoneForDisplay,
} from "../../../utils/reportWindowLabel";
import {
  StatisticsEmptyState,
  statisticsPageMinHeight,
} from "../Statistics/components/statisticsEmptyState";
import { ReportEvidencePointersBlock } from "./ReportEvidencePointersBlock";
import { ReportGlossarySection } from "./ReportGlossarySection";
import {
  ConditionAnalysisSection,
} from "./ConditionAnalysisSection";
import { ManagementExplorerSection } from "./ManagementExplorerSection";
import { ReportProcessingState, ReportFailedState } from "./ReportProcessingState";
import {
  DeleteReportsDialog,
  type DeleteReportsDialogRequest,
} from "./components/DeleteReportsDialog";
import { ReportFindingsDisclaimerBox } from "../../../components/Reports/ReportFindingsDisclaimerBox";
import { subscribeReportReady, dispatchReportReady } from "../../../utils/reportReadyEvents";
import {
  isReportStillProcessingStatus,
  scheduleReportProcessingFallbackPoll,
} from "../../../utils/reportProcessingFallbackPoll";
import {
  parseReportFindings,
  reportHasInsufficientTesOutput,
  formatFindingConfidence,
} from "../../../utils/reportFindings";
import { getEvidencePointerWarnings } from "../../../utils/tesEvidencePointers";
import {
  getReportTypeDisplayLabel,
  reportDetailSectionKeys,
  reportDetailTabLabels,
  reportDetailTabTitles,
  isTradeManagementReportType,
  reportTypeRequiresInstrumentSetup,
  isTradeAnalysisReportType,
  isEntryAnalysisReportType,
  normalizeReportTypeKey,
  type ReportDetailSectionKey,
} from "../../../utils/reportTypeRules";
import {
  mergeReportEvidenceSources,
  type MarketContextNavigationTarget,
} from "../../../utils/marketContextNavigation";
import {
  extractManagementSnapshotFields,
} from "../../../utils/tradeManagementReport";
import OverviewMetrics from "../Statistics/components/OverviewMetrics";
import { reportPageFieldFocusProps, reportPageFieldFocusSx } from "./reportPageFieldFocus";
import { ExecutionRulesSimulatorPanel } from "../ExecutionRulesSimulator/ExecutionRulesSimulatorPanel";
import { SimulatorComparisonQuota } from "../ExecutionRulesSimulator/SimulatorComparisonQuota";
import GradientButton from "../Profile/components/GradientButton";
import { ReportNotesHubPanel } from "../../../components/Notes/ReportNotesHubPanel";
import { ReportSectionTabLayout } from "../../../components/Notes/ReportSectionTabLayout";
import {
  REPORTS_DETAIL_FIELD_DESC_CLASS,
  REPORTS_DETAIL_FINDING_META_LABEL_CLASS,
  useReportsDetailColors,
} from "./reportsDetailTheme";
import { ReportTabNotesSection } from "../../../components/Notes/ReportTabNotesSection";
import { ConfiguratorStyleMenu } from "../../../components/Reports/ConfiguratorStyleMenu";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import {
  METRIC_TOOLTIP_ARROW_CLASS_NAME,
  METRIC_TOOLTIP_BODY_CLASS,
  METRIC_TOOLTIP_TITLE_CLASS,
  metricTooltipShellClassName,
} from "@/components/ui/metric-tooltip";
import { PineScriptCodeBlock } from "../../../components/Reports/PineScriptCodeBlock";
import { WorkspaceDrawerActionRow } from "../Workspace/WorkspaceDrawerActionRow";
import {
  WorkspaceDrawerActionsMenu,
  type WorkspaceDrawerActionItem,
} from "../Workspace/WorkspaceDrawerActionsMenu";
import { Button as UiButton } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Field, FieldDescription, FieldLabel } from "@/components/ui/field";
import { Download, HelpCircle, Pencil, Trash2 } from "lucide-react";
import { ArrowLeftIcon, type ArrowLeftIconHandle } from "../../../components/ui/arrow-left-animated";
import { ArrowRightIcon, type ArrowRightIconHandle } from "../../../components/ui/arrow-right-animated";
import {
  buildReportDetailMetaItems,
  REPORT_DETAIL_CARD_BORDER,
  reportDetailSectionCardProps,
  ReportsCardMetaRowWithBadges,
} from "./components/ReportsCardChrome";

type RouteParams = { reportId: string };

export type ReportDetailLocationState = {
  reportDisplayTitle?: string;
  /** Opened from the Workspace hub — breadcrumb parent is Workspace, not Reports. */
  fromWorkspace?: true;
};

const REPORT_TITLE_MAX = 255;

/** Minimum findings rail width on md+ so cards are not clipped; narrative width is capped via `min(..., calc(100% - reserve))`. */
const REPORT_FINDINGS_COLUMN_MIN_MD_PX = 320;
/** Matches `gap={{ md: 6 }}` (1.5rem) between narrative and findings columns. */
const REPORT_NARRATIVE_FINDINGS_GAP_MD_PX = 24;
const REPORT_FINDINGS_LAYOUT_RESERVE_MD_PX =
  REPORT_FINDINGS_COLUMN_MIN_MD_PX + REPORT_NARRATIVE_FINDINGS_GAP_MD_PX;

function formatCreatedAtForDisplay(value?: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;

  const day = d.getDate();
  const suffix =
    day % 10 === 1 && day % 100 !== 11
      ? "st"
      : day % 10 === 2 && day % 100 !== 12
        ? "nd"
        : day % 10 === 3 && day % 100 !== 13
          ? "rd"
          : "th";
  const monthYear = d.toLocaleDateString("en-GB", {
    month: "long",
    year: "numeric",
  });
  const localTime = d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
  return `${day}${suffix} ${monthYear} | ${localTime}`;
}

const REPORT_PRIMARY_FONT = "var(--font-primary)";

const REPORT_OVERVIEW_FIELD_LABEL_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-normal text-[color:var(--brand-tropical-surf)]";

const REPORT_OVERVIEW_FIELD_DESC_CLASS = REPORTS_DETAIL_FIELD_DESC_CLASS;

const FINDING_ACCORDION_FIELD_LABEL_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-medium text-[color:var(--brand-tropical-surf)]";

/** shadcn gradient badges for finding meta values (matches Trade Log / report header badges). */
const FINDING_META_BADGE_BASE =
  "border-0 bg-transparent font-[family-name:var(--font-primary)] font-medium normal-case tracking-normal text-white shadow-none";

const FINDING_META_BADGE_PRIORITY_CLASS = `${FINDING_META_BADGE_BASE} bg-[image:linear-gradient(135deg,#F45B0B,#F49113)]`;
const FINDING_META_BADGE_CONFIDENCE_CLASS = `${FINDING_META_BADGE_BASE} bg-[image:linear-gradient(135deg,#38BBD1,#3EEAEC)]`;
const FINDING_META_BADGE_TYPE_CLASS = `${FINDING_META_BADGE_BASE} bg-[image:linear-gradient(135deg,#6B7280,#9CA3AF)]`;

/** Same copy pattern as Statistics detailed-tab metric tooltips (title + description). */
const FINDING_META_TOOLTIPS: Record<string, string> = {
  Priority:
    "A score from 0 to 1 (higher means more urgent) ranking this finding against the others in the same report. The model sets it from expected impact, risk, and confidence. Larger values should be addressed sooner.",
  Confidence:
    "A score from 0 to 1 (higher means more certain) for how strongly the evidence in this report supports the finding. Values near 1 indicate strong, consistent support; values near 0 indicate weaker or mixed evidence.",
  Type:
    "Type describes the kind of recommendation (for example: entry timing, risk control, sizing, or execution).",
};

function FindingMetaLabelTooltip(props: {
  label: string;
  onLabelClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}): React.ReactElement {
  const description = FINDING_META_TOOLTIPS[props.label];
  if (!description) {
    return (
      <span
        data-report-finding-meta-label=""
        className={REPORTS_DETAIL_FINDING_META_LABEL_CLASS}
      >
        {props.label}
      </span>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          data-report-finding-meta-label=""
          className={`shrink-0 cursor-help whitespace-nowrap border-0 bg-transparent p-0 underline decoration-dotted underline-offset-2 ${REPORTS_DETAIL_FINDING_META_LABEL_CLASS}`}
          onClick={props.onLabelClick}
        >
          {props.label}
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        sideOffset={4}
        arrowClassName={METRIC_TOOLTIP_ARROW_CLASS_NAME}
        className={metricTooltipShellClassName()}
      >
        <div className="text-left">
          <p className={METRIC_TOOLTIP_TITLE_CLASS}>{props.label}</p>
          <p className={`mt-1 text-[11px] leading-snug ${METRIC_TOOLTIP_BODY_CLASS}`}>
            {description}
          </p>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}

const REPORT_SECTION_TAB_VALUES = [
  "overview",
  "market",
  "simulator",
  "review",
  "pine",
  "notes",
] as const;

type ReportSectionTabValue = (typeof REPORT_SECTION_TAB_VALUES)[number];

/** Short labels — shadcn `TabsTrigger` labels (Trade Log / Statistics pill tabs). */
const REPORT_SECTION_TAB_LABELS = [
  "Overview",
  "Market",
  "Simulator",
  "Review",
  "Pinescript",
  "Notes",
] as const;

/** Full section titles — `title` on tab triggers and footer nav CTAs. */
const REPORT_SECTION_TAB_TITLES = [
  "Overview",
  "Entry Analysis",
  "Simulator",
  "Trade review",
  "Pinescript",
  "Notes",
] as const;
function FindingHypothesisBlock(props: {
  hypothesis: string;
  subtleText: string;
  previewClamped: boolean;
}): React.ReactElement {
  return (
    <Box w="100%" minW={0}>
      <Text fontSize="xs" color="#38BBD1" mb="4px" fontFamily={REPORT_PRIMARY_FONT}>
        Hypothesis
      </Text>
      <Text
        fontSize="sm"
        color={props.subtleText}
        lineHeight="1.5"
        fontFamily={REPORT_PRIMARY_FONT}
        noOfLines={props.previewClamped ? 4 : undefined}
      >
        {props.hypothesis}
      </Text>
    </Box>
  );
}

function ReportSectionTabNavFooter(props: {
  tabIndex: number;
  sectionTabLabels: readonly string[];
  sectionTabTitles: readonly string[];
  onNavigate: (nextIndex: number) => void;
  borderColor: string;
}): JSX.Element {
  const { tabIndex, onNavigate, borderColor, sectionTabLabels, sectionTabTitles } = props;
  const backArrowRef = useRef<ArrowLeftIconHandle | null>(null);
  const forwardArrowRef = useRef<ArrowRightIconHandle | null>(null);
  const prevIdx = tabIndex > 0 ? tabIndex - 1 : null;
  const nextIdx = tabIndex < sectionTabLabels.length - 1 ? tabIndex + 1 : null;
  if (prevIdx === null && nextIdx === null) {
    return <></>;
  }

  return (
    <Flex
      justify="space-between"
      align="stretch"
      flexWrap="wrap"
      gap={3}
      mt={{ base: 6, md: 8 }}
      pt={{ base: 5, md: 6 }}
      borderTopWidth="1px"
      borderColor={borderColor}
    >
      <Box flex="1" minW={{ base: "100%", sm: "200px" }} display="flex" justifyContent="flex-start">
        {prevIdx !== null ? (
          <UiButton
            type="button"
            variant="gradient"
            size="sm"
            data-font="primary"
            className="h-8 shrink-0 px-5 active:translate-y-0"
            title={sectionTabTitles[prevIdx]}
            onMouseEnter={() => backArrowRef.current?.startAnimation()}
            onMouseLeave={() => backArrowRef.current?.stopAnimation()}
            onClick={() => onNavigate(prevIdx)}
          >
            <ArrowLeftIcon
              ref={backArrowRef}
              data-icon="inline-start"
              size={16}
              className="shrink-0 text-white"
              aria-hidden
            />
            <span className="uppercase tracking-wide">{sectionTabLabels[prevIdx]}</span>
          </UiButton>
        ) : null}
      </Box>
      <Box flex="1" minW={{ base: "100%", sm: "200px" }} display="flex" justifyContent="flex-end">
        {nextIdx !== null ? (
          <UiButton
            type="button"
            variant="gradient"
            size="sm"
            data-font="primary"
            className="h-8 shrink-0 px-5 active:translate-y-0"
            title={sectionTabTitles[nextIdx]}
            onMouseEnter={() => forwardArrowRef.current?.startAnimation()}
            onMouseLeave={() => forwardArrowRef.current?.stopAnimation()}
            onClick={() => onNavigate(nextIdx)}
          >
            <span className="uppercase tracking-wide">{sectionTabLabels[nextIdx]}</span>
            <ArrowRightIcon
              ref={forwardArrowRef}
              data-icon="inline-end"
              size={16}
              className="shrink-0 text-white"
              aria-hidden
            />
          </UiButton>
        ) : null}
      </Box>
    </Flex>
  );
}

export type ReportDetailProps = {
  layout?: "page" | "embedded";
  reportId?: string;
  onDeleted?: () => void;
  /** When embedded in the workspace drawer, closes the panel. */
  onClose?: () => void;
  /** When opened from a workspace report node, attach new sims under that node. */
  workspaceSimulationContext?: import("../../../types/workspace").WorkspaceCreateContext;
  /**
   * Resolve policy canvas attach to the simulation node for a backtest
   * (report drawer — never use the report node as policy parent).
   */
  resolveWorkspacePolicyAttach?: (
    backtestId: string
  ) => import("../../../types/workspace").WorkspaceCreateContext | null | undefined;
  /** Refresh workspace canvas after a simulation is saved onto it. */
  onWorkspaceSimulationSaved?: (backtestId: string) => void | Promise<void>;
  /** After Save as policy version from the report simulator (workspace hydrate). */
  onStrategyVersionSaved?: (backtestId?: string) => void | Promise<void>;
};

export default function ReportDetail({
  layout = "page",
  reportId: reportIdProp,
  onDeleted,
  onClose,
  workspaceSimulationContext,
  resolveWorkspacePolicyAttach,
  onWorkspaceSimulationSaved,
  onStrategyVersionSaved,
}: ReportDetailProps = {}): JSX.Element {
  const { reportId: reportIdParam } = useParams<RouteParams>();
  const embedded = layout === "embedded";
  const reportId = (reportIdProp ?? reportIdParam)?.trim() ?? "";
  const history = useHistory();
  const location = useLocation<ReportDetailLocationState>();
  const shadcnInset = useShadcnInsetChrome();
  const { setActions: setInsetHeaderActions } = useShadcnInsetHeaderActions();
  const {
    subtleText,
    textColor,
    borderColor,
    insetSurfaceBg: evidencePreBg,
    evidencePreBorder,
  } = useReportsDetailColors();
  const renameModalBg = useColorModeValue("white", "var(--sidebar)");
  const renameModalBorder = useColorModeValue("gray.200", "gray.600");
  const renameInputBorder = useColorModeValue("gray.300", "gray.600");
  const renameInputText = useColorModeValue("gray.700", "var(--sidebar-foreground)");
  const cancelOutlineBorder = useColorModeValue("red.400", "red.300");
  const cancelOutlineHoverBorder = useColorModeValue("red.500", "red.200");
  const cancelOutlineText = useColorModeValue("red.500", "red.200");
  const { isOpen: renameOpen, onOpen: onRenameOpen, onClose: onRenameClose } = useDisclosure();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [report, setReport] = useState<Report | null>(null);
  const [policySimLinkedBacktestId, setPolicySimLinkedBacktestId] = useState<string | null>(null);
  const [savingStatus, setSavingStatus] = useState<"published" | "archived" | null>(null);
  const [renameTitleDraft, setRenameTitleDraft] = useState("");
  const [savingTitle, setSavingTitle] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleteReportsRequest, setDeleteReportsRequest] =
    useState<DeleteReportsDialogRequest | null>(null);
  const fromWorkspace = location.state?.fromWorkspace === true;
  const reportsListExitPath = fromWorkspace ? WORKSPACE_HUB_PATH : "/reports";
  const pendingReportTitle = useMemo(() => {
    const fromNav = location.state?.reportDisplayTitle?.trim();
    return fromNav || null;
  }, [location.state?.reportDisplayTitle]);

  const reportBreadcrumbTitle = report
    ? getReportDisplayTitle(report)
    : pendingReportTitle;
  useShadcnInsetDynamicPageTitle(embedded ? null : reportBreadcrumbTitle, {
    parent: !embedded && fromWorkspace ? WORKSPACE_HUB_BREADCRUMB : null,
  });

  const reportDetailPageMinHeight = embedded ? undefined : statisticsPageMinHeight(shadcnInset);

  const load = useCallback(async (options?: { quiet?: boolean }) => {
    if (!reportId) {
      setError("Missing report id in URL.");
      setReport(null);
      setLoading(false);
      return null;
    }
    const quiet = Boolean(options?.quiet);
    if (!quiet) {
      setLoading(true);
      setError(null);
    }
    try {
      const data = await getReport(reportId);
      if (data == null || typeof data !== "object") {
        if (!quiet) {
          setError("Report data was empty or invalid.");
          setReport(null);
        }
        return null;
      }
      const id = (data as { id?: unknown }).id;
      if (id == null || String(id).trim() === "") {
        if (!quiet) {
          setError("Report response was missing a valid id.");
          setReport(null);
        }
        return null;
      }
      setReport(data);
      return data;
    } catch (e) {
      if (!quiet) {
        setError(e instanceof Error ? e.message : "Failed to load report.");
        setReport(null);
      }
      return null;
    } finally {
      if (!quiet) setLoading(false);
    }
  }, [reportId]);

  useEffect(() => {
    void load();
  }, [load]);

  useEffect(() => {
    return subscribeReportReady((detail) => {
      if (!reportId || detail.reportId !== reportId) return;
      void load({ quiet: true });
    });
  }, [load, reportId]);

  // WS is primary; bounded fallback if report_ready was missed (1/min, max 5).
  useEffect(() => {
    if (!reportId || report?.status !== "processing") return;
    return scheduleReportProcessingFallbackPoll(async () => {
      const data = await load({ quiet: true });
      if (!data || isReportStillProcessingStatus(data.status)) return;
      dispatchReportReady({
        reportId,
        status: String(data.status ?? "published"),
      });
    });
  }, [load, report?.status, reportId]);

  // Soft safety when the tab is focused again (missed events while hidden).
  useEffect(() => {
    if (report?.status !== "processing") return;
    const onVisible = () => {
      if (document.visibilityState === "visible") void load({ quiet: true });
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [load, report?.status]);

  const isTradeManagement = Boolean(report && isTradeManagementReportType(report.report_type));
  const isEntryAnalysisReport = Boolean(report && isEntryAnalysisReportType(report.report_type));
  const isTradeAnalysis = Boolean(report && isTradeAnalysisReportType(report.report_type));
  const { accounts, activeAccountCode } = useActiveBrokerAccount();
  const activeAccount = useMemo(
    () => accounts.find((account) => account.accountCode === activeAccountCode) ?? null,
    [accounts, activeAccountCode]
  );
  const instrumentSetupPending = activeAccount?.instrumentSetupPending === true;
  const gateExitRegimeDetail = Boolean(
    report && reportTypeRequiresInstrumentSetup(report.report_type)
  );
  const { checking: instrumentSetupChecking, blocking: instrumentSetupBlocking } =
    useInstrumentSetupGateStatus(!gateExitRegimeDetail);
  const showReportDetailLoading =
    (loading && !report && !error) ||
    (Boolean(report) && !error && instrumentSetupChecking);
  const reportDetailLoadingTitle =
    loading && !report
      ? pendingReportTitle
        ? `Loading report: '${pendingReportTitle}'`
        : "Loading report"
      : "Checking instrument setup…";
  const reportDetailLoadingDescription =
    loading && !report
      ? "Please wait while we load this report."
      : "Please wait while we confirm market data is ready.";
  const blockReportSimulator =
    instrumentSetupBlocking ||
    shouldBlockSimulator({
      instrumentSetupPending,
      variant: "report",
      report,
    });
  const gatedReportFeatureLabel = isTradeManagement ? "Exit Placement" : "Entry Analysis";

  const reportSectionKeys = useMemo(
    () => (report ? reportDetailSectionKeys(report.report_type) : (["overview"] as const)),
    [report]
  );
  const sectionTabLabels = useMemo(
    () => (report ? reportDetailTabLabels(report.report_type) : (["Overview"] as const)),
    [report]
  );
  const sectionTabTitles = useMemo(
    () => (report ? reportDetailTabTitles(report.report_type) : (["Overview"] as const)),
    [report]
  );

  /** Formatted analysis window (dates or preset); not necessarily rendered as a Chakra Badge. */
  const AlertAny = Alert as any;
  const AlertIconAny = AlertIcon as any;
  const AlertDescriptionAny = AlertDescription as any;

  const reportPolicyRowVersion = useMemo(() => {
    const spec = (report as any)?.market_context_spec;
    const mcVersion = (report as any)?.market_context_version;
    const snapMcVersion = (report?.input_snapshot as any)?.meta?.market_context_version;
    const raw = String(spec ?? mcVersion ?? snapMcVersion ?? "").toLowerCase();
    if (raw.includes("pine")) return "policy_row.pine_v1" as const;
    return "policy_row.v1" as const;
  }, [report]);

  const narrativeForDisplay = useMemo(() => {
    if (!report?.narrative) return "—";
    return enrichNarrativeSessionReferences(report.narrative, report.input_snapshot);
  }, [report?.narrative, report?.input_snapshot]);
  const createdAtDisplay = useMemo(() => formatCreatedAtForDisplay(report?.created_at), [report?.created_at]);

  const snapshotTradesForReview = useMemo(() => {
    const snapshot = report?.input_snapshot as Record<string, unknown> | null | undefined;
    const trades = snapshot?.trades;
    if (!Array.isArray(trades)) return [] as Trade[];
    return (trades as unknown[]).map((t) => {
      if (t && typeof t === "object" && "entryDate" in t) {
        const row = t as Trade & { trade_id?: string };
        const id = String(row.id ?? row.trade_id ?? "").trim();
        return id && id !== row.id ? { ...row, id } : row;
      }
      if (t && typeof t === "object" && ("entry_date" in t || "entry_time" in t)) {
        try {
          return backendTradeToFrontendTrade(t as Parameters<typeof backendTradeToFrontendTrade>[0]);
        } catch {
          const row = t as Record<string, unknown>;
          return {
            id: String(row.id ?? row.trade_id ?? ""),
            symbol: String(row.symbol ?? ""),
            type: (row.trade_type ?? row.type ?? "buy") as Trade["type"],
            status: (row.status ?? "closed") as Trade["status"],
            entryDate: String(row.entry_date ?? row.entry_time ?? row.entryDate ?? ""),
            entryPrice: Number(row.entry_price ?? row.entryPrice ?? 0),
            entryQuantity: Number(row.entry_quantity ?? row.entryQuantity ?? 0),
            entryFees: Number(row.entry_fees ?? row.entryFees ?? 0),
            entryValue: Number(row.entry_value ?? row.entryValue ?? 0),
            exitDate: String(row.exit_date ?? row.exit_time ?? row.exitDate ?? "") || undefined,
            exitPrice:
              row.exit_price != null || row.exitPrice != null
                ? Number(row.exit_price ?? row.exitPrice)
                : undefined,
            netPnL:
              row.net_pnl != null || row.netPnL != null
                ? Number(row.net_pnl ?? row.netPnL)
                : undefined,
            grossPnL:
              row.gross_pnl != null || row.grossPnL != null
                ? Number(row.gross_pnl ?? row.grossPnL)
                : undefined,
          } as Trade;
        }
      }
      return t as Trade;
    });
  }, [report?.input_snapshot]);

  const reportTradeDateRange = useMemo((): DateRange => {
    const parseYmd = (raw: string | null | undefined): Date | null => {
      if (!raw || typeof raw !== "string") return null;
      const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw.trim());
      if (!m) return null;
      const y = parseInt(m[1], 10);
      const mo = parseInt(m[2], 10);
      const d = parseInt(m[3], 10);
      if (!Number.isFinite(y) || !Number.isFinite(mo) || !Number.isFinite(d)) return null;
      return new Date(y, mo - 1, d, 0, 0, 0, 0);
    };
    return {
      startDate: parseYmd(report?.start_date),
      endDate: parseYmd(report?.end_date),
    };
  }, [report?.end_date, report?.start_date]);

  const brokerAccountCodeForReview = useMemo(() => {
    return report?.broker_account_code ?? ((report?.input_snapshot as any)?.broker_account_code ?? null);
  }, [report]);

  const candleTimeframeForReport = useMemo(() => {
    const raw = getReportCandleTimeframeForDisplay(report);
    if (
      raw === "1m" ||
      raw === "5m" ||
      raw === "15m" ||
      raw === "30m" ||
      raw === "1h" ||
      raw === "4h" ||
      raw === "1d"
    ) {
      return raw;
    }
    return "1h";
  }, [report]);

  const reportOverviewMetricsBundle = useMemo(() => {
    const backend = extractReportWindowTradeStatistics(report?.input_snapshot);
    if (!backend) return null;
    return {
      backend,
      statistics: backendTradeStatisticsToFrontend(backend),
    };
  }, [report?.input_snapshot]);

  const reportTimezoneFromPayload = useMemo(() => getReportRunTimezoneForDisplay(report), [report]);
  const [reportTimezoneSupplemental, setReportTimezoneSupplemental] = useState<string | null>(null);

  useEffect(() => {
    if (!report?.id) {
      setReportTimezoneSupplemental(null);
      setPolicySimLinkedBacktestId(null);
      return;
    }
    if (getReportRunTimezoneForDisplay(report)) {
      setReportTimezoneSupplemental(null);
      return;
    }
    setReportTimezoneSupplemental(null);
    let cancelled = false;
    const reportIdStable = report.id;
    const brokerForBacktest =
      report.broker_account_code ?? ((report.input_snapshot as { broker_account_code?: string } | null)?.broker_account_code);

    (async () => {
      try {
        const cfg = await fetchReportPolicySimConfig(reportIdStable);
        if (cancelled) return;
        const linked =
          typeof cfg?.linked_backtest_id === "string" && cfg.linked_backtest_id.trim()
            ? cfg.linked_backtest_id.trim()
            : null;
        setPolicySimLinkedBacktestId(linked);
        const si = cfg?.scope_inputs as Record<string, unknown> | undefined;
        const z = typeof si?.timezone === "string" ? si.timezone.trim() : "";
        if (z) {
          setReportTimezoneSupplemental(z);
          return;
        }
      } catch {
        // ignore — fall through to backtest lookup
      }

      if (cancelled || !brokerForBacktest) return;

      try {
        const { backtests } = await listBacktests({
          broker_account_code: brokerForBacktest,
          report_id: reportIdStable,
          limit: 1,
          offset: 0,
        });
        const first = backtests?.[0];
        if (cancelled || !first) return;

        const tz = timezoneFromBacktestRow(first);
        if (cancelled) return;
        if (tz) setReportTimezoneSupplemental(tz);
      } catch {
        if (!cancelled) setReportTimezoneSupplemental(null);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [report]);

  const displayRecordedTimezone = reportTimezoneFromPayload || reportTimezoneSupplemental;

  const timezoneUtcReferenceDate = useMemo(() => {
    const raw = report?.created_at;
    if (!raw) return new Date();
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? new Date() : d;
  }, [report?.created_at]);

  const displayRecordedTimezoneWithUtc = useMemo(() => {
    if (!displayRecordedTimezone) return null;
    return formatIanaTimezoneWithUtcOffset(displayRecordedTimezone, timezoneUtcReferenceDate);
  }, [displayRecordedTimezone, timezoneUtcReferenceDate]);

  const { timezone: dashboardDisplayTimezoneIana } = useUserNotificationTimezone();
  const displayDashboardTimezoneWithUtc = useMemo(() => {
    if (!dashboardDisplayTimezoneIana) return null;
    return formatIanaTimezoneWithUtcOffset(dashboardDisplayTimezoneIana, new Date());
  }, [dashboardDisplayTimezoneIana]);

  const [fetchedTradesForReview, setFetchedTradesForReview] = useState<Trade[]>([]);
  const [fetchedTradesForReviewLoading, setFetchedTradesForReviewLoading] = useState(false);
  const [fetchedTradesForReviewError, setFetchedTradesForReviewError] = useState<string | null>(null);

  const reportingTimeZoneForTrades =
    displayRecordedTimezone || dashboardDisplayTimezoneIana || Intl.DateTimeFormat().resolvedOptions().timeZone;

  /** Inclusive local calendar day the report was created — PnL / live trades stop here. */
  const reportCreatedAsOfYmd = useMemo(() => {
    const raw = report?.created_at;
    if (!raw) return null;
    const created = new Date(raw);
    if (Number.isNaN(created.getTime())) return null;
    return formatDateAsCalendarDayInTimeZone(created, reportingTimeZoneForTrades);
  }, [report?.created_at, reportingTimeZoneForTrades]);

  /** Exact report generation instant — Trade Review must not include later closed trades. */
  const reportCreatedAsOfExactMs = useMemo(() => {
    const raw = report?.created_at;
    if (!raw) return null;
    const ms = Date.parse(raw);
    return Number.isFinite(ms) ? ms : null;
  }, [report?.created_at]);

  const reportCreatedAsOfEndMs = useMemo(() => {
    if (!reportCreatedAsOfYmd) return null;
    return endOfIanaCalendarDayUtc(reportCreatedAsOfYmd, reportingTimeZoneForTrades).getTime();
  }, [reportCreatedAsOfYmd, reportingTimeZoneForTrades]);

  const reportCreatedAsOfLabel = useMemo(() => {
    if (!reportCreatedAsOfYmd) return null;
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }).format(new Date(`${reportCreatedAsOfYmd}T12:00:00`));
  }, [reportCreatedAsOfYmd]);

  /** Only when the ready report UI can use Trade Review — never while Generating… */
  const reportStatus = report?.status;
  const reportReadyForTradeReview =
    Boolean(reportStatus) &&
    reportStatus !== "processing" &&
    reportStatus !== "failed" &&
    reportStatus !== "draft";
  const shouldFetchTradesForReview =
    reportReadyForTradeReview &&
    (isTradeAnalysis || isTradeManagement || isEntryAnalysisReport);

  useEffect(() => {
    if (!shouldFetchTradesForReview) {
      setFetchedTradesForReview([]);
      setFetchedTradesForReviewError(null);
      setFetchedTradesForReviewLoading(false);
      return;
    }
    if (!report?.id || !brokerAccountCodeForReview?.trim()) {
      setFetchedTradesForReview([]);
      setFetchedTradesForReviewError(null);
      setFetchedTradesForReviewLoading(false);
      return;
    }
    if (snapshotTradesForReview.length > 0) {
      const snapshotHasPnl = snapshotTradesForReview.some((t) => {
        const row = t as Trade & Record<string, unknown>;
        return (
          (t.netPnL != null && Number.isFinite(Number(t.netPnL))) ||
          (row.net_pnl != null && Number.isFinite(Number(row.net_pnl))) ||
          (t.grossPnL != null && Number.isFinite(Number(t.grossPnL))) ||
          (row.gross_pnl != null && Number.isFinite(Number(row.gross_pnl)))
        );
      });
      if (snapshotHasPnl) {
        setFetchedTradesForReview([]);
        setFetchedTradesForReviewError(null);
        setFetchedTradesForReviewLoading(false);
        return;
      }
    }

    let cancelled = false;
    void (async () => {
      setFetchedTradesForReviewLoading(true);
      setFetchedTradesForReviewError(null);
      try {
        const asOfYmd = reportCreatedAsOfYmd;
        const win = resolveReportTradeReviewFetchWindow({
          dateRange: reportTradeDateRange,
          timeframe: report.timeframe ?? "all-time",
          reportingTimeZone: reportingTimeZoneForTrades,
          asOfYmd,
          cohortPeriod: report.cohort_period,
        });
        const opts: Parameters<typeof fetchTrades>[0] = {
          broker_account_code: brokerAccountCodeForReview.trim(),
          // Report trade review is the report cohort — open live positions that merely
          // opened inside the window are not report trades.
          status: "closed",
        };
        const reportSymbol = report.symbol?.trim();
        if (reportSymbol) opts.symbol = reportSymbol;

        if (win.kind === "local") {
          opts.local_period = win.period;
        } else {
          opts.timeframe = win.timeframe;
        }
        const response = await fetchTrades(opts);
        if (cancelled) return;
        const list = Array.isArray(response?.trades) ? response.trades.map(backendTradeToFrontendTrade) : [];
        setFetchedTradesForReview(list);
      } catch (e) {
        if (cancelled) return;
        setFetchedTradesForReview([]);
        setFetchedTradesForReviewError(e instanceof Error ? e.message : "Failed to load trades for review.");
      } finally {
        if (!cancelled) setFetchedTradesForReviewLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    brokerAccountCodeForReview,
    isEntryAnalysisReport,
    report?.id,
    report?.status,
    report?.symbol,
    report?.timeframe,
    reportTradeDateRange,
    reportingTimeZoneForTrades,
    reportCreatedAsOfYmd,
    report?.cohort_period,
    shouldFetchTradesForReview,
    snapshotTradesForReview.length,
  ]);

  const tradesForReview = useMemo(() => {
    const source =
      snapshotTradesForReview.length > 0 ? snapshotTradesForReview : fetchedTradesForReview;
    // Keep report review scoped to report/cohort trades — live opens that only
    // started inside the window should not appear in this table.
    const closed = source.filter((t) => String(t.status ?? "").trim().toLowerCase() !== "open");
    return filterTradesExitedOnOrBefore(closed, reportCreatedAsOfExactMs);
  }, [fetchedTradesForReview, reportCreatedAsOfExactMs, snapshotTradesForReview]);

  const tradesForReviewLoading = useMemo(() => {
    if (snapshotTradesForReview.length > 0) return false;
    return fetchedTradesForReviewLoading;
  }, [fetchedTradesForReviewLoading, snapshotTradesForReview.length]);

  const marketCohortPreview = useMarketCohortPreview(report?.id ?? "");

  const [marketCohortOverlayStatsByKey, setMarketCohortOverlayStatsByKey] = useState<
    Record<string, CohortPreviewStats | null>
  >({});

  const tradesByIdForCohortStats = useMemo(
    () =>
      new Map(tradesForReview.map((t) => [String(t.id ?? "").trim().toLowerCase(), t])),
    [tradesForReview]
  );

  useEffect(() => {
    const activeKeys = new Set(marketCohortPreview.previews.map((p) => p.rowKey));
    setMarketCohortOverlayStatsByKey((prev) => {
      let changed = false;
      const next: Record<string, CohortPreviewStats | null> = {};
      for (const [key, value] of Object.entries(prev)) {
        if (activeKeys.has(key)) {
          next[key] = value;
        } else {
          changed = true;
        }
      }
      return changed ? next : prev;
    });
  }, [marketCohortPreview.previews]);

  const onUpsertCohortOverlayStats = useCallback(
    (rowKey: string, nextStats: CohortPreviewStats | null) => {
      setMarketCohortOverlayStatsByKey((prev) => upsertCohortOverlayStats(prev, rowKey, nextStats));
    },
    []
  );

  const onPreviewConditionBucket = useCallback(
    (row, sliceContext, analysisScope, label) => {
      marketCohortPreview.previewConditionBucket(row, sliceContext, analysisScope, label);
    },
    [marketCohortPreview.previewConditionBucket]
  );

  const onPreviewConditionSituation = useCallback(
    (row, sliceContext, analysisScope, label) => {
      marketCohortPreview.previewConditionSituation(row, sliceContext, analysisScope, label);
    },
    [marketCohortPreview.previewConditionSituation]
  );

  const onPreviewConditionSlice = useCallback(
    (slice, sliceContext, label, expectedSampleSize) => {
      marketCohortPreview.previewConditionSlice(slice, sliceContext, label, expectedSampleSize);
    },
    [marketCohortPreview.previewConditionSlice]
  );

  const onPreviewConditionSummaryRow = useCallback(
    (tableKey, row, sliceContext, label) => {
      marketCohortPreview.previewConditionSummaryRow(
        tableKey,
        row,
        sliceContext,
        label,
        row.sample_size
      );
    },
    [marketCohortPreview.previewConditionSummaryRow]
  );

  const onPreviewExplorerSlice = useCallback(
    (row: ManagementExplorerSliceRow) => {
      const sliceId = buildExplorerSliceId(row);
      if (!sliceId && !String(row.segment_key ?? "").trim()) return;
      marketCohortPreview.previewExplorerSlice(
        row,
        exitPlacementSliceDisplayLabel(row) || sliceId || "Context",
        row.sample_size
      );
    },
    [marketCohortPreview.previewExplorerSlice]
  );

  const brokerAccountCodeForBacktests = brokerAccountCodeForReview;
  const [linkedBacktestsLoading, setLinkedBacktestsLoading] = useState(true);
  const [linkedBacktestsError, setLinkedBacktestsError] = useState<string | null>(null);
  const [linkedBacktests, setLinkedBacktests] = useState<Backtest[]>([]);
  const [simulatorComparisonRunsUsed, setSimulatorComparisonRunsUsed] = useState(0);

  const [overlayBacktestId, setOverlayBacktestId] = useState<string>("");
  const [overlayEnabled, setOverlayEnabled] = useState(true);
  const [overlayTradeIdsLoading, setOverlayTradeIdsLoading] = useState(false);
  const [overlayTradeIdsError, setOverlayTradeIdsError] = useState<string | null>(null);
  const [overlayTradeIds, setOverlayTradeIds] = useState<{ kept: string[]; removed: string[]; source?: string } | null>(null);

  const [strategyDetailLoading, setStrategyDetailLoading] = useState(false);
  const [strategyDetailError, setStrategyDetailError] = useState<string | null>(null);
  const [strategyDetail, setStrategyDetail] = useState<any>(null);
  const [selectedPolicyVersionId, setSelectedPolicyVersionId] = useState<string>("");
  const [pineLoading, setPineLoading] = useState(false);
  const [pineError, setPineError] = useState<string | null>(null);
  const [pineCompileUnsupportedPaths, setPineCompileUnsupportedPaths] = useState<string[]>([]);
  const [pineCompileUnsupportedOps, setPineCompileUnsupportedOps] = useState<string[]>([]);
  const [pineScript, setPineScript] = useState<string>("");

  const loadLinkedBacktests = useCallback(async () => {
    if (!report?.id) {
      setLinkedBacktestsLoading(false);
      return;
    }
    if (!brokerAccountCodeForBacktests) {
      setLinkedBacktests([]);
      setLinkedBacktestsLoading(false);
      return;
    }
    setLinkedBacktestsLoading(true);
    setLinkedBacktestsError(null);
    try {
      const resp = await listBacktests({
        broker_account_code: brokerAccountCodeForBacktests,
        report_id: report.id,
        status: undefined,
        limit: 50,
        offset: 0,
        include_result: true,
      });
      const rows = Array.isArray(resp?.backtests) ? resp.backtests : [];
      setLinkedBacktests(dedupeBacktestsById(rows));
    } catch (e) {
      setLinkedBacktests([]);
      setLinkedBacktestsError(e instanceof Error ? e.message : "Failed to load linked simulations.");
    } finally {
      setLinkedBacktestsLoading(false);
    }
  }, [brokerAccountCodeForBacktests, report?.id]);

  useEffect(() => {
    void loadLinkedBacktests();
  }, [loadLinkedBacktests]);

  useEffect(() => {
    if (reportSectionTab !== "simulator") return;
    void loadLinkedBacktests();
  }, [loadLinkedBacktests, reportSectionTab]);

  /** Drop stale overlay selection if the sim was deleted (comparison remove / list refresh). */
  useEffect(() => {
    const id = overlayBacktestId.trim();
    if (!id) return;
    if (linkedBacktests.some((b) => b.id === id)) return;
    setOverlayBacktestId("");
    setOverlayEnabled(false);
  }, [linkedBacktests, overlayBacktestId]);

  useEffect(() => {
    setOverlayTradeIds(null);
    setOverlayTradeIdsError(null);
  }, [overlayBacktestId]);

  useEffect(() => {
    if (!overlayEnabled) return;
    if (!overlayBacktestId) return;
    if (overlayTradeIds || overlayTradeIdsLoading) return;
    let cancelled = false;
    const requestedId = overlayBacktestId;
    (async () => {
      setOverlayTradeIdsLoading(true);
      setOverlayTradeIdsError(null);
      try {
        const resp = await getBacktestTradeIds(requestedId);
        // Only apply if still relevant (avoid clobbering after selection changes).
        if (cancelled || requestedId !== overlayBacktestId) return;
        setOverlayTradeIds({
          kept: Array.isArray(resp?.kept_trade_ids) ? resp.kept_trade_ids : [],
          removed: Array.isArray(resp?.removed_trade_ids) ? resp.removed_trade_ids : [],
          source: typeof resp?.source === "string" ? resp.source : undefined,
        });
      } catch (e) {
        if (cancelled || requestedId !== overlayBacktestId) return;
        setOverlayTradeIds(null);
        setOverlayTradeIdsError(e instanceof Error ? e.message : "Failed to load simulation trade IDs.");
      } finally {
        if (!cancelled) setOverlayTradeIdsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // Important: do NOT depend on overlayTradeIdsLoading, or setting it true will cancel the in-flight request.
  }, [overlayBacktestId, overlayEnabled, overlayTradeIds]);

  const loadStrategyDetail = useCallback(async (opts?: { selectCurrentVersion?: boolean }) => {
    const strategyId = report?.strategy_id;
    if (!strategyId) {
      setStrategyDetail(null);
      setSelectedPolicyVersionId("");
      return;
    }
    setStrategyDetailLoading(true);
    setStrategyDetailError(null);
    try {
      const detail = await getReportStrategyDetail(strategyId);
      setStrategyDetail(detail);
      const currentId = detail?.current_policy_version_id || "";
      const versions = Array.isArray(detail?.policy_versions) ? detail.policy_versions : [];
      const latestId = versions.length ? versions[0]?.id : "";
      setSelectedPolicyVersionId((prev) => {
        if (opts?.selectCurrentVersion) {
          return currentId || latestId || "";
        }
        const stillValid = typeof prev === "string" && prev && versions.some((v: any) => String(v?.id) === prev);
        return stillValid ? prev : currentId || latestId || "";
      });
    } catch (e) {
      setStrategyDetail(null);
      setSelectedPolicyVersionId("");
      setStrategyDetailError(e instanceof Error ? e.message : "Failed to load strategy detail.");
    } finally {
      setStrategyDetailLoading(false);
    }
  }, [report?.strategy_id]);

  useEffect(() => {
    void loadStrategyDetail();
  }, [loadStrategyDetail]);

  const onGeneratePine = useCallback(async () => {
    const strategyId = report?.strategy_id;
    const versionId = selectedPolicyVersionId;
    if (!strategyId || !versionId) return;
    setPineLoading(true);
    setPineError(null);
    setPineCompileUnsupportedPaths([]);
    setPineCompileUnsupportedOps([]);
    try {
      const resp = await getReportStrategyPolicyVersionPineScript(strategyId, versionId, {
        policy_row_version: reportPolicyRowVersion,
      });
      setPineScript(typeof resp?.pinescript === "string" ? resp.pinescript : "");
    } catch (e) {
      setPineScript("");
      if (e instanceof ReportStrategyPineCompileError) {
        setPineError(e.message);
        setPineCompileUnsupportedPaths(e.unsupported_paths || []);
        setPineCompileUnsupportedOps(e.unsupported_ops || []);
      } else {
        setPineError(e instanceof Error ? e.message : "Failed to generate Pinescript.");
      }
    } finally {
      setPineLoading(false);
    }
  }, [report?.strategy_id, reportPolicyRowVersion, selectedPolicyVersionId]);

  const copyPine = useCallback(async () => {
    if (!pineScript) return;
    try {
      await navigator.clipboard.writeText(pineScript);
      toast.success("Copied Pinescript");
    } catch (e) {
      presentMutationError(e, "Copy failed");
    }
  }, [pineScript]);

  const formatPolicyVersionMenuLabel = useCallback((v: any) => {
    if (!v) return "";
    const isCurrent = strategyDetail?.current_policy_version_id && v?.id === strategyDetail.current_policy_version_id;
    const verNo = typeof v?.version_number === "number" ? `v${v.version_number}` : null;
    const srcName =
      typeof v?.source_backtest_title === "string" && v.source_backtest_title.trim() ? v.source_backtest_title.trim() : null;
    const title = typeof v?.title === "string" && v.title.trim() ? v.title.trim() : null;
    const base = title || srcName || v?.id;
    return `${isCurrent ? "Current • " : ""}${verNo ? `${verNo} • ` : ""}${base}${srcName && title ? ` • ${srcName}` : ""}`;
  }, [strategyDetail]);

  const policyVersionMenuOptions = useMemo(() => {
    const versions = Array.isArray(strategyDetail?.policy_versions) ? strategyDetail.policy_versions : [];
    return versions.map((v: any) => ({
      value: String(v.id),
      label: formatPolicyVersionMenuLabel(v),
    }));
  }, [strategyDetail, formatPolicyVersionMenuLabel]);

  const policyVersionMenuCurrentLabel = useMemo(() => {
    if (!policyVersionMenuOptions.length) return "No strategy versions";
    const found = policyVersionMenuOptions.find((o) => o.value === selectedPolicyVersionId);
    return found?.label ?? policyVersionMenuOptions[0]?.label ?? "Strategy version";
  }, [policyVersionMenuOptions, selectedPolicyVersionId]);

  /** Strategy title for PineScript card — never shows `strategy_id`; uses names or a neutral placeholder. */
  const pineScriptStrategyDisplayName = useMemo(() => {
    if (!report?.strategy_id) return "";
    if (strategyDetailLoading && !strategyDetail?.name && !report?.strategy?.name) return "Loading…";
    const fromDetail = typeof strategyDetail?.name === "string" ? strategyDetail.name.trim() : "";
    if (fromDetail) return fromDetail;
    const fromReport = typeof report?.strategy?.name === "string" ? report.strategy.name.trim() : "";
    if (fromReport) return fromReport;
    return "Strategy";
  }, [report?.strategy_id, report?.strategy?.name, strategyDetail?.name, strategyDetailLoading]);

  const activeOverlayBacktest = useMemo(() => {
    const id =
      overlayEnabled && overlayBacktestId.trim()
        ? overlayBacktestId.trim()
        : linkedBacktestIdForReview;
    if (!id) return undefined;
    return linkedBacktests.find((b) => b.id === id);
  }, [linkedBacktests, linkedBacktestIdForReview, overlayBacktestId, overlayEnabled]);

  const isTmSimulationOverlay = useMemo(
    () =>
      isTradeManagement ||
      (!isEntryAnalysisReport && isTradeManagementBacktest(activeOverlayBacktest)) ||
      report?.simulation_overlay_mode === "baseline_vs_simulated",
    [activeOverlayBacktest, isEntryAnalysisReport, isTradeManagement, report?.simulation_overlay_mode]
  );

  const policyOverlayForReview = useMemo(() => {
    if (isTmSimulationOverlay) return null;
    if (!overlayBacktestId || !overlayEnabled || !overlayTradeIds) return null;
    return {
      kept_trade_ids: overlayTradeIds.kept,
      removed_trade_ids: overlayTradeIds.removed,
    };
  }, [isTmSimulationOverlay, overlayBacktestId, overlayEnabled, overlayTradeIds]);

  /** Baseline cohort for the selected simulation overlay (kept ∪ removed). */
  const simulatorOverlayCohortTradeIds = useMemo(() => {
    if (!overlayEnabled || !overlayTradeIds) return null;
    const ids = [...overlayTradeIds.kept, ...overlayTradeIds.removed]
      .map((id) => String(id ?? "").trim())
      .filter(Boolean);
    return ids.length > 0 ? ids : null;
  }, [overlayEnabled, overlayTradeIds]);

  const tradesForSimulatorReview = useMemo(() => {
    if (!simulatorOverlayCohortTradeIds) return tradesForReview;
    const allowed = new Set(simulatorOverlayCohortTradeIds.map((id) => id.toLowerCase()));
    return tradesForReview.filter((t) => allowed.has(String(t.id ?? "").trim().toLowerCase()));
  }, [simulatorOverlayCohortTradeIds, tradesForReview]);

  const displayReportTypeLabel = useMemo(
    () => getReportTypeDisplayLabel(report?.report_type),
    [report?.report_type]
  );

  const managementSnapshot = useMemo(
    () => extractManagementSnapshotFields(report?.input_snapshot),
    [report?.input_snapshot]
  );

  const marketWindowOverview = useMemo(() => {
    const snap = report?.input_snapshot;
    if (!snap || typeof snap !== "object" || Array.isArray(snap)) return null;
    const mc = (snap as Record<string, unknown>).market_context;
    if (!mc || typeof mc !== "object" || Array.isArray(mc)) return null;
    const overview = (mc as Record<string, unknown>).market_window_overview;
    if (!overview || typeof overview !== "object" || Array.isArray(overview)) return null;
    return overview as Record<string, unknown>;
  }, [report?.input_snapshot]);

  const linkedBacktestIdForReview = useMemo(() => {
    if (policySimLinkedBacktestId) return policySimLinkedBacktestId;
    const fromReport = report?.linked_backtest_id;
    return typeof fromReport === "string" && fromReport.trim() ? fromReport.trim() : null;
  }, [policySimLinkedBacktestId, report?.linked_backtest_id]);

  const simulationOverlayModeForReview = useMemo(() => {
    if (!isTmSimulationOverlay) return undefined;
    const raw = report?.simulation_overlay_mode;
    return typeof raw === "string" && raw.trim() ? raw.trim() : "baseline_vs_simulated";
  }, [isTmSimulationOverlay, report?.simulation_overlay_mode]);

  const overlayBacktestSimulationRows = useMemo(() => {
    if (!overlayBacktestId) return undefined;
    const bt = linkedBacktests.find((b) => b.id === overlayBacktestId);
    const rows = bt?.result?.simulated_trades;
    return Array.isArray(rows) && rows.length > 0 ? rows : undefined;
  }, [linkedBacktests, overlayBacktestId]);

  const overlaySimulatedLegs = useMemo((): Array<"sl" | "tp"> | undefined => {
    if (!overlayBacktestId) return undefined;
    const bt = linkedBacktests.find((b) => b.id === overlayBacktestId);
    if (!bt) return undefined;
    const scope = bt.scope as Record<string, unknown> | undefined;
    const simulatedLegsRaw = scope?.simulated_legs;
    if (Array.isArray(simulatedLegsRaw)) {
      const legs = simulatedLegsRaw.filter((leg): leg is "sl" | "tp" => leg === "sl" || leg === "tp");
      return legs.length > 0 ? legs : undefined;
    }
    const simulateLegs = scope?.simulate_legs;
    if (simulateLegs === "sl_only") return ["sl"];
    if (simulateLegs === "tp_only") return ["tp"];
    if (simulateLegs === "both") return ["sl", "tp"];
    return undefined;
  }, [linkedBacktests, overlayBacktestId]);

  const backtestIdForSimulatorReview = useMemo(() => {
    if (overlayEnabled && overlayBacktestId.trim()) return overlayBacktestId.trim();
    return linkedBacktestIdForReview ?? undefined;
  }, [linkedBacktestIdForReview, overlayBacktestId, overlayEnabled]);

  const isTmSimulationOverlayForBacktest = useCallback(
    (bt: Backtest | undefined) =>
      isTradeManagement ||
      (!isEntryAnalysisReport && isTradeManagementBacktest(bt)) ||
      report?.simulation_overlay_mode === "baseline_vs_simulated",
    [isEntryAnalysisReport, isTradeManagement, report?.simulation_overlay_mode]
  );

  const getBacktestSimulationRows = useCallback(
    (backtestId: string) => {
      const bt = linkedBacktests.find((b) => b.id === backtestId);
      const rows = bt?.result?.simulated_trades;
      return Array.isArray(rows) && rows.length > 0 ? (rows as Array<Record<string, unknown>>) : undefined;
    },
    [linkedBacktests]
  );

  const getSimulatedLegsForBacktest = useCallback(
    (backtestId: string): Array<"sl" | "tp"> | undefined => {
      const bt = linkedBacktests.find((b) => b.id === backtestId);
      if (!bt) return undefined;
      const scope = bt.scope as Record<string, unknown> | undefined;
      const simulatedLegsRaw = scope?.simulated_legs;
      if (Array.isArray(simulatedLegsRaw)) {
        const legs = simulatedLegsRaw.filter((leg): leg is "sl" | "tp" => leg === "sl" || leg === "tp");
        return legs.length > 0 ? legs : undefined;
      }
      const simulateLegs = scope?.simulate_legs;
      if (simulateLegs === "sl_only") return ["sl"];
      if (simulateLegs === "tp_only") return ["tp"];
      if (simulateLegs === "both") return ["sl", "tp"];
      return undefined;
    },
    [linkedBacktests]
  );

  const comparisonTradeReviewSharedProps = useMemo(
    () => ({
      brokerAccountCode: brokerAccountCodeForReview,
      trades: tradesForReview,
      tradesLoading: tradesForReviewLoading,
      tradesError: fetchedTradesForReviewError,
      reportId: report?.id ?? "",
      reportTimeframe: report?.timeframe,
      reportStartDate: report?.start_date,
      reportEndDate: report?.end_date,
      reportTimezone: reportTimezoneFromPayload ?? reportingTimeZoneForTrades,
      cohortPeriod: report?.cohort_period,
      inputSnapshot: report?.input_snapshot,
      defaultCandleTimeframe: candleTimeframeForReport,
      recordedTimezoneLabel: displayRecordedTimezoneWithUtc || undefined,
      linkedBacktests,
      requireInstrumentSetup: true,
      asOfEndMs: reportCreatedAsOfExactMs,
    }),
    [
      brokerAccountCodeForReview,
      tradesForReview,
      tradesForReviewLoading,
      fetchedTradesForReviewError,
      report,
      reportTimezoneFromPayload,
      reportingTimeZoneForTrades,
      candleTimeframeForReport,
      displayRecordedTimezoneWithUtc,
      linkedBacktests,
      reportCreatedAsOfExactMs,
    ]
  );

  useEffect(() => {
    if (!linkedBacktestIdForReview) return;
    setOverlayBacktestId((prev) => prev || linkedBacktestIdForReview);
    setOverlayEnabled(true);
  }, [linkedBacktestIdForReview]);

  const reportWindowLabel = useMemo(() => {
    if (!report) return "All time";
    return getReportCohortWindowLabel(report);
  }, [report]);

  const reportDetailMetaItems = useMemo(() => {
    if (!report) return [];
    return buildReportDetailMetaItems({
      accountCode: report.broker_account_code,
      dateLabel: reportWindowLabel,
      createdAtDisplay,
      candleTimeframe: candleTimeframeForReport,
      timezoneLabel: displayRecordedTimezoneWithUtc,
    });
  }, [
    report,
    reportWindowLabel,
    createdAtDisplay,
    candleTimeframeForReport,
    displayRecordedTimezoneWithUtc,
  ]);

  const visibleFindings = useMemo(() => parseReportFindings(report), [report]);
  const insufficientTesOutput = useMemo(() => reportHasInsufficientTesOutput(report), [report]);

  /** Accordion: at most one finding expanded; click again to close. */
  const [expandedFindingId, setExpandedFindingId] = useState<string | null>(null);

  useEffect(() => {
    setExpandedFindingId(null);
  }, [report?.id]);

  /** Report body sections — shadcn pill tabs (`@/components/ui/tabs`), same as Trade Log / Statistics. */
  const [reportSectionTab, setReportSectionTab] = useState<ReportDetailSectionKey>("overview");

  useEffect(() => {
    if (!reportSectionKeys.includes(reportSectionTab)) {
      setReportSectionTab(reportSectionKeys[0] ?? "overview");
    }
  }, [reportSectionKeys, reportSectionTab]);

  const reportSectionTabIndex = useMemo(() => {
    const idx = reportSectionKeys.indexOf(reportSectionTab);
    return idx >= 0 ? idx : 0;
  }, [reportSectionKeys, reportSectionTab]);

  /** Tuned on layout so narrative intrinsic height ≈ findings rail (cards + headings). */
  const [narrativeFr, setNarrativeFr] = useState(2.25);
  const narrativeFrRef = useRef(2.25);
  useEffect(() => {
    narrativeFrRef.current = narrativeFr;
  }, [narrativeFr]);
  const reportNarrativeFindingsGridRef = useRef<HTMLDivElement | null>(null);

  /** Footer prev/next: change tab then scroll to top of the page (not the tab strip). */
  const navigateReportSectionFromFooter = useCallback(
    (nextIndex: number) => {
      const next = reportSectionKeys[nextIndex];
      if (next) setReportSectionTab(next);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    [reportSectionKeys]
  );

  const [explorerFocusSliceId, setExplorerFocusSliceId] = useState<string | null>(null);
  const [explorerFocusNonce, setExplorerFocusNonce] = useState(0);
  const [marketContextFocus, setMarketContextFocus] = useState<MarketContextNavigationTarget | null>(null);
  const [marketContextFocusNonce, setMarketContextFocusNonce] = useState(0);

  const reportEvidenceSnapshot = useMemo(
    () => mergeReportEvidenceSources(report?.input_snapshot, report?.analysis_evidence),
    [report?.analysis_evidence, report?.input_snapshot]
  );

  const evidencePointerWarnings = useMemo(
    () => getEvidencePointerWarnings(report?.input_snapshot),
    [report?.input_snapshot]
  );

  const onOpenExplorerSlice = useCallback(
    (sliceId: string) => {
      setExplorerFocusSliceId(sliceId);
      setExplorerFocusNonce((n) => n + 1);
      if (reportSectionKeys.includes("market")) {
        setReportSectionTab("market");
      }
    },
    [reportSectionKeys]
  );

  const onDismissExplorerFocus = useCallback(() => {
    setExplorerFocusSliceId(null);
  }, []);

  const onOpenMarketContext = useCallback(
    (target: MarketContextNavigationTarget) => {
      // Drop leftover focus / Radix outside-pointer locks from Overview controls/menus.
      if (typeof document !== "undefined") {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
        document.body.style.pointerEvents = "";
        for (const cls of Array.from(document.body.classList)) {
          if (cls.startsWith("block-interactivity-")) {
            document.body.classList.remove(cls);
          }
        }
      }
      setMarketContextFocus(target);
      setMarketContextFocusNonce((n) => n + 1);
      if (reportSectionKeys.includes("market")) {
        setReportSectionTab("market");
        const scrollToEvidenceRow = Boolean(
          target.highlightSituation?.trim() || target.highlightBucket?.trim()
        );
        if (!scrollToEvidenceRow) {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
        const restore = () => {
          document.body.style.pointerEvents = "";
          for (const cls of Array.from(document.body.classList)) {
            if (cls.startsWith("block-interactivity-")) {
              document.body.classList.remove(cls);
            }
          }
        };
        const poll = window.setInterval(restore, 100);
        window.setTimeout(() => window.clearInterval(poll), 2000);
      }
    },
    [reportSectionKeys]
  );

  const onLoadExplorerPolicyInSimulator = useCallback(
    (policy: PolicyTreeV2, options?: { label?: string; segmentKey?: string }) => {
      setPendingManagementPolicy(policy);
      setPendingManagementSegmentKey(options?.segmentKey?.trim() || null);
      setReportSectionTab("simulator");
      toast.success("Exit placement policy loaded", {
        description: options?.label
          ? `${options.label}. Run simulation in the Simulator tab.`
          : "Open the Simulator tab to run backtest.",
      });
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    []
  );

  /**
   * One-shot narrative/findings column balance. No ResizeObserver — any element observed
   * still resized when our column width animates, which caused endless flip-flop retuning.
   * We only remeasure on report/narrative/findings changes, after collapse settles, and on viewport resize.
   */
  useLayoutEffect(() => {
    let cancelled = false;
    let resizeDebounce: ReturnType<typeof setTimeout> | null = null;
    const delayedTimers: ReturnType<typeof setTimeout>[] = [];

    const measureFindingsIntrinsic = (root: HTMLElement) => {
      const heading = root.querySelector("[data-report-findings-heading]") as HTMLElement | null;
      const cards = root.querySelectorAll("[data-report-finding-card]");
      let h = heading ? heading.getBoundingClientRect().height + 8 : 0;
      cards.forEach((node, i) => {
        h += (node as HTMLElement).getBoundingClientRect().height;
        if (i < cards.length - 1) h += 12;
      });
      return h;
    };

    const frToNarrativeWidthPct = (fr: number) => (100 * fr) / (fr + 1);
    /** Quantized steps avoid bouncing between adjacent float solutions. */
    const NARRATIVE_FR_STEP = 0.25;

    const runTune = () => {
      if (cancelled) return;
      const layoutRoot = reportNarrativeFindingsGridRef.current;
      if (!layoutRoot || typeof window === "undefined" || window.innerWidth < 768) return;

      const narrativeBody = layoutRoot.querySelector("[data-report-narrative-body]") as HTMLElement | null;
      const narrativeCol = layoutRoot.querySelector("[data-report-narrative-column]") as HTMLElement | null;
      if (!narrativeBody || !narrativeCol) return;

      let fr = narrativeFrRef.current;
      const prevInlineWidth = narrativeCol.style.width;

      for (let k = 0; k < 22; k++) {
        const pct = frToNarrativeWidthPct(fr);
        narrativeCol.style.width = `min(${pct}%, calc(100% - ${REPORT_FINDINGS_LAYOUT_RESERVE_MD_PX}px))`;
        void layoutRoot.offsetHeight;
        const hf = measureFindingsIntrinsic(layoutRoot);
        const hn = narrativeBody.getBoundingClientRect().height;
        if (Math.abs(hn - hf) <= 18) break;
        if (hn > hf) fr = Math.min(6, fr + 0.05);
        else fr = Math.max(1.1, fr - 0.05);
      }

      narrativeCol.style.width = prevInlineWidth;
      const raw = Number(fr.toFixed(3));
      const quantized = Math.round(raw / NARRATIVE_FR_STEP) * NARRATIVE_FR_STEP;
      const next = Math.min(6, Math.max(1.1, Number(quantized.toFixed(2))));

      if (!cancelled) {
        if (Math.abs(next - narrativeFrRef.current) < NARRATIVE_FR_STEP - 0.001) return;
        setNarrativeFr(next);
      }
    };

    const scheduleResizeTune = () => {
      if (resizeDebounce != null) clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(() => {
        resizeDebounce = null;
        if (!cancelled) requestAnimationFrame(() => requestAnimationFrame(runTune));
      }, 280);
    };

    const onWindowResize = () => scheduleResizeTune();
    window.addEventListener("resize", onWindowResize);
    const mq = window.matchMedia("(min-width: 768px)");
    mq.addEventListener("change", scheduleResizeTune);

    requestAnimationFrame(() => requestAnimationFrame(runTune));
    delayedTimers.push(
      setTimeout(() => {
        if (!cancelled) runTune();
      }, 400)
    );

    return () => {
      cancelled = true;
      if (resizeDebounce != null) clearTimeout(resizeDebounce);
      delayedTimers.forEach(clearTimeout);
      window.removeEventListener("resize", onWindowResize);
      mq.removeEventListener("change", scheduleResizeTune);
    };
  }, [report?.id, narrativeForDisplay, visibleFindings.length, reportSectionTab]);

  const openRenameModal = useCallback(() => {
    if (!report) return;
    setRenameTitleDraft((report.title ?? "").trim());
    onRenameOpen();
  }, [onRenameOpen, report]);

  const onOpenRenameModalClick = useCallback(() => {
    openRenameModal();
  }, [openRenameModal]);

  const onSaveReportTitle = useCallback(async () => {
    if (!report) return;
    setSavingTitle(true);
    setError(null);
    try {
      const trimmed = renameTitleDraft.trim().slice(0, REPORT_TITLE_MAX);
      const updated = await updateReport(report.id, { title: trimmed });
      setReport(updated);
      toast.success("Report name updated");
      onRenameClose();
    } catch (e) {
      presentMutationError(e, "Update failed");
    } finally {
      setSavingTitle(false);
    }
  }, [onRenameClose, renameTitleDraft, report]);
  const onDeleteReport = useCallback(async () => {
    if (!report) return;
    setDeleting(true);
    try {
      await deleteReport(report.id);
      toast.success("Report deleted");
      setDeleteReportsRequest(null);
      if (embedded) {
        onDeleted?.();
      } else {
        history.push(reportsListExitPath);
      }
    } catch (e) {
      presentMutationError(e, "Delete failed");
    } finally {
      setDeleting(false);
    }
  }, [embedded, history, onDeleted, report, reportsListExitPath]);

  const closeDeleteReportsDialog = useCallback(
    (open: boolean) => {
      if (!open && !deleting) {
        setDeleteReportsRequest(null);
      }
    },
    [deleting]
  );

  const onDeleteClick = useCallback(() => {
    if (!report) return;
    setDeleteReportsRequest({
      mode: "single",
      reportId: report.id,
    });
  }, [report]);

  const exportInputSnapshotJson = useCallback(() => {
    if (!report) return;
    if (!report.input_snapshot) {
      setError("No input snapshot available on this report.");
      return;
    }

    const json = JSON.stringify(report.input_snapshot, null, 2);
    const blob = new Blob([json], { type: "application/json;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `report_${report.id}_input_snapshot.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }, [report]);

  const drawerActionItems = useMemo((): WorkspaceDrawerActionItem[] => {
    return [
      {
        id: "rename-report",
        label: "Rename report",
        disabled: !report,
        icon: <Pencil className="size-4 shrink-0 text-current" aria-hidden />,
        onSelect: onOpenRenameModalClick,
      },
      {
        id: "export-report",
        label: "Export",
        disabled: !report,
        icon: <Download className="size-4 shrink-0 text-current" aria-hidden />,
        onSelect: exportInputSnapshotJson,
      },
      {
        id: "delete-report",
        label: deleting ? "Deleting…" : "Delete",
        disabled: !report || deleting,
        tone: "destructive",
        separatorBefore: true,
        icon: <Trash2 className="size-4 shrink-0 text-current" aria-hidden />,
        onSelect: () => {
          void onDeleteClick();
        },
      },
      {
        id: "need-help",
        label: "Need Help?",
        href: "https://help.tesseratrades.com/reports",
        tone: "brand",
        separatorBefore: true,
        icon: <HelpCircle className="size-4 shrink-0 text-current" aria-hidden />,
      },
    ];
  }, [deleting, exportInputSnapshotJson, onDeleteClick, onOpenRenameModalClick, report]);

  const headerToolbar = useMemo(
    () => (
      <WorkspaceDrawerActionRow onClose={onClose}>
        <WorkspaceDrawerActionsMenu items={drawerActionItems} />
      </WorkspaceDrawerActionRow>
    ),
    [drawerActionItems, onClose]
  );

  useEffect(() => {
    if (embedded || !shadcnInset) {
      setInsetHeaderActions(null);
      return;
    }
    if (showReportDetailLoading) {
      setInsetHeaderActions(null);
      return;
    }
    setInsetHeaderActions(headerToolbar);
    return () => setInsetHeaderActions(null);
  }, [embedded, shadcnInset, headerToolbar, setInsetHeaderActions, showReportDetailLoading]);

  const errorBanner = error ? (
    <AlertAny status="error" borderRadius="6px">
      <AlertIconAny />
      <AlertDescriptionAny>{error}</AlertDescriptionAny>
    </AlertAny>
  ) : null;

  const page = (
    <Box
      data-reports-page=""
      data-reports-detail-page=""
      data-report-detail-layout={layout}
      display="flex"
      flexDirection="column"
      pt={embedded || shadcnInset ? 0 : { base: "100px", md: "80px", lg: "40px" }}
      pb={embedded ? 0 : "24px"}
      px={embedded || shadcnInset ? 0 : "24px"}
      gap={embedded ? "16px" : "24px"}
      flex={embedded ? 1 : undefined}
      minH={embedded ? "100%" : reportDetailPageMinHeight}
      h={embedded ? "100%" : undefined}
      sx={reportPageFieldFocusSx}
    >
      {(embedded || !shadcnInset) && !showReportDetailLoading ? headerToolbar : null}

      <Modal isOpen={renameOpen} onClose={onRenameClose} isCentered>
        <ModalOverlay />
        <ModalContent
          bg={renameModalBg}
          border="1px solid"
          borderColor={renameModalBorder}
          borderRadius="6px"
          textAlign="center"
        >
          <ModalHeader
            fontFamily="'Urbanist', sans-serif"
            color="#38BBD1"
            pb={2}
            textAlign="center"
          >
            Rename report
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pt={0} px={6} pb={2}>
            <Box maxW="420px" mx="auto" w="100%">
              <Input
                value={renameTitleDraft}
                onChange={(e) => setRenameTitleDraft(e.target.value.slice(0, REPORT_TITLE_MAX))}
                onKeyDown={(e) => {
                  if (e.key === "Enter") void onSaveReportTitle();
                  if (e.key === "Escape") onRenameClose();
                }}
                h="44px"
                borderRadius="6px"
                border="1px solid"
                borderColor={renameInputBorder}
                bg="transparent"
                color={renameInputText}
                fontSize="sm"
                fontFamily="'Urbanist', sans-serif"
                px={3}
                {...reportPageFieldFocusProps}
                maxLength={REPORT_TITLE_MAX}
              />
            </Box>
          </ModalBody>
          <ModalFooter gap={3} justifyContent="center" flexWrap="wrap" w="100%">
            <Button
              px="20px"
              py="10px"
              h="40px"
              borderRadius="6px"
              border="1px solid"
              borderColor={cancelOutlineBorder}
              bg="transparent"
              color={cancelOutlineText}
              fontSize="xs"
              fontFamily="'IBM Plex Sans', sans-serif"
              fontWeight="medium"
              textTransform="uppercase"
              transition="all 0.2s"
              _hover={{
                borderColor: cancelOutlineHoverBorder,
                opacity: 0.9,
              }}
              _active={{
                opacity: 0.8,
                transform: "scale(0.98)",
              }}
              onClick={onRenameClose}
            >
              Cancel
            </Button>
            <GradientButton
              showArrow={false}
              fontSize="xs"
              px="20px"
              py="10px"
              h="40px"
              borderRadius="6px"
              onClick={() => void onSaveReportTitle()}
              isLoading={savingTitle}
              loadingText="Saving…"
            >
              Save
            </GradientButton>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {showReportDetailLoading ? (
        <Flex
          flex="1"
          minH={embedded ? "100%" : 0}
          w="100%"
          align="center"
          justify="center"
        >
          <StatisticsEmptyState
            variant="loading"
            fillParent
            title={reportDetailLoadingTitle}
            description={reportDetailLoadingDescription}
          />
        </Flex>
      ) : (
        <>
      {error && (
        <Alert status="error" borderRadius="6px">
          <AlertIcon />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      {!loading && !report && !error && (
        <Alert status="warning" borderRadius="6px">
          <AlertIcon />
          <AlertDescription>
            This report could not be displayed. Try refreshing the page, or go back to the reports list.
          </AlertDescription>
        </Alert>
      )}

      {report && (
        <VStack
          align="stretch"
          spacing="16px"
          data-reports-detail-page=""
          flex={report.status === "processing" ? "1" : undefined}
          minH={report.status === "processing" ? (embedded ? "100%" : 0) : undefined}
        >
          <Card {...reportDetailSectionCardProps}>
            <CardHeader pb="0" w="100%" minW={0}>
              <Box data-reports-card-chrome="" w="100%" minW={0}>
                <Heading
                  as="h2"
                  noOfLines={3}
                  title={getReportDisplayTitle(report)}
                  fontSize={{ base: "2xl", md: "3xl" }}
                  color="#38BBD1"
                  fontWeight="normal"
                  fontFamily="'Urbanist', sans-serif"
                  lineHeight="1.15"
                  mt={0}
                  mb={0}
                  minW={0}
                  maxW="100%"
                >
                  {getReportDisplayTitle(report)}
                </Heading>
                <ReportsCardMetaRowWithBadges
                  metaItems={reportDetailMetaItems}
                  reportType={report.report_type}
                  reportTypeLabel={displayReportTypeLabel}
                  symbol={report.symbol}
                />
              </Box>
            </CardHeader>
          </Card>

          {report.status === "processing" ? (
            <ReportProcessingState reportId={report.id} title={getReportDisplayTitle(report)} />
          ) : null}

          {report.status === "failed" ? (
            <ReportFailedState
              title={getReportDisplayTitle(report)}
              {...(() => {
                const userErr = parseReportUserError(report.user_error, report.error_message);
                return {
                  errorMessage: userErr.message,
                  errorAction: userErr.action,
                };
              })()}
            />
          ) : null}

          {report.status !== "processing" && report.status !== "failed" ? (
          <Tabs
            data-trade-log-tabs=""
            className="w-full"
            value={reportSectionTab}
            onValueChange={(value) => setReportSectionTab(value as ReportDetailSectionKey)}
          >
            <div className="w-full overflow-x-auto overflow-y-hidden">
              <TabsList className="min-w-max">
                {reportSectionKeys.map((value, i) => (
                  <TabsTrigger key={value} value={value} title={sectionTabTitles[i]}>
                    {sectionTabLabels[i]}
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>

            {reportSectionKeys.includes("overview") ? (
            <TabsContent
              value="overview"
              className="mt-0 data-[state=inactive]:hidden"
            >
            <InstrumentSetupGate
              featureLabel={gatedReportFeatureLabel}
              bypass={!gateExitRegimeDetail}
            >
            <Box data-report-overview="" display="flex" flexDirection="column" alignItems="stretch" w="100%">
            <Card {...reportDetailSectionCardProps}>
            <CardHeader pb={{ base: 3, md: 4 }}>
              <Box flex="1" minW={{ base: "100%", md: "260px" }}>
                <Text
                  fontSize={{ base: "2xl", md: "3xl" }}
                  color="#38BBD1"
                  fontWeight="normal"
                  fontFamily={REPORT_PRIMARY_FONT}
                  lineHeight="1.15"
                >
                  Overview
                </Text>
                <Text fontSize="sm" color={subtleText} mt={1} fontFamily={REPORT_PRIMARY_FONT}>
                  Report narrative, structured findings, and evidence for this run.
                </Text>
              </Box>
            </CardHeader>
            <CardBody display="flex" flexDirection="column" pt={0} w="full">
              <Stack ref={reportNarrativeFindingsGridRef} w="100%" spacing={{ base: 5, md: 6 }}>
                <Box
                  data-report-narrative-column
                  minW={0}
                  w="100%"
                  display="flex"
                  flexDirection="column"
                  h="auto"
                >
                  <Field className="w-full">
                    <FieldLabel htmlFor="report-overview-narrative" className={REPORT_OVERVIEW_FIELD_LABEL_CLASS}>
                      Narrative
                    </FieldLabel>
                    <FieldDescription className={REPORT_OVERVIEW_FIELD_DESC_CLASS}>
                      Written analysis for this report run.
                    </FieldDescription>
                  <Box
                    id="report-overview-narrative"
                    data-report-narrative-body
                    flexShrink={0}
                    fontSize="sm"
                    fontWeight="normal"
                    borderWidth="1px"
                    borderStyle="solid"
                    borderColor={REPORT_DETAIL_CARD_BORDER}
                    borderRadius="6px"
                    p="12px"
                    color={subtleText}
                    w="100%"
                    maxH={{ base: "none", md: "min(78vh, 900px)" }}
                    overflowY={{ base: "visible", md: "auto" }}
                    fontFamily={REPORT_PRIMARY_FONT}
                    sx={{
                      borderColor: `${REPORT_DETAIL_CARD_BORDER} !important`,
                      "& a": { color: "cyan.400" },
                      "& p": {
                        marginTop: "0",
                        marginBottom: "10px",
                        fontFamily: REPORT_PRIMARY_FONT,
                      },
                      "& ul, & ol": { paddingLeft: "20px", marginTop: "0", marginBottom: "10px" },
                      "& code": {
                        fontFamily: "mono",
                        fontSize: "0.9em",
                        background: "rgba(0,0,0,0.06)",
                        padding: "2px 6px",
                        borderRadius: "6px",
                        _dark: { background: "rgba(255,255,255,0.06)" },
                      },
                      "& pre": {
                        overflow: "auto",
                        padding: "10px",
                        borderRadius: "6px",
                        background: "rgba(0,0,0,0.06)",
                        _dark: { background: "rgba(255,255,255,0.06)" },
                      },
                      "& pre code": { background: "transparent", padding: 0 },
                      "& strong": {
                        color: "#38BBD1",
                        fontFamily: REPORT_PRIMARY_FONT,
                        fontWeight: 700,
                      },
                      "& blockquote": {
                        borderLeft: "3px solid",
                        borderColor: "cyan.300",
                        paddingLeft: "10px",
                        color: subtleText,
                      },
                    }}
                  >
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{narrativeForDisplay}</ReactMarkdown>
                  </Box>
                  <ReportFindingsDisclaimerBox />
                  </Field>
                </Box>

                <Box>
                  <Field className="w-full">
                    <FieldLabel
                      htmlFor="report-overview-findings"
                      data-report-findings-heading
                      className={REPORT_OVERVIEW_FIELD_LABEL_CLASS}
                    >
                      Findings
                    </FieldLabel>
                    <FieldDescription className={REPORT_OVERVIEW_FIELD_DESC_CLASS}>
                      Structured recommendations with assumptions and supporting evidence.
                    </FieldDescription>
              {import.meta.env.DEV && evidencePointerWarnings.length > 0 ? (
                <AlertAny status="warning" borderRadius="6px" mb={3} mt={2}>
                  <AlertIconAny />
                  <AlertDescriptionAny fontSize="sm" fontFamily={REPORT_PRIMARY_FONT}>
                    <Text fontWeight="semibold" mb={1}>
                      Evidence pointer diagnostics (dev)
                    </Text>
                    <VStack align="stretch" spacing={1}>
                      {evidencePointerWarnings.map((w, i) => (
                        <Text key={i} fontSize="xs">
                          {w}
                        </Text>
                      ))}
                    </VStack>
                  </AlertDescriptionAny>
                </AlertAny>
              ) : null}
              {insufficientTesOutput ? (
                <AlertAny status="warning" borderRadius="6px" mb={3}>
                  <AlertIconAny />
                  <AlertDescriptionAny fontSize="sm" fontFamily={REPORT_PRIMARY_FONT}>
                    TES did not return enough structured findings for this run. Review the narrative and metrics;
                    consider regenerating with a larger sample or different window.
                  </AlertDescriptionAny>
                </AlertAny>
              ) : null}
              {visibleFindings.length > 0 ? (
                <Box id="report-overview-findings" data-report-findings-rail>
                  <Box data-report-findings-accordion="" borderRadius="6px" overflow="hidden">
                    <Accordion
                      type="single"
                      collapsible
                      value={expandedFindingId ?? ""}
                      onValueChange={(value) => setExpandedFindingId(value || null)}
                      className="space-y-2 border-0"
                    >
                      {visibleFindings.map((rec, idx) => {
                        const recId = rec.id || `rec_${idx}`;
                        const findingTitle = rec.title || `Finding ${idx + 1}`;
                        const findingExpanded = expandedFindingId === recId;
                        const confidenceLabel = formatFindingConfidence(rec.confidence);
                        return (
                          <AccordionItem
                            key={recId}
                            value={recId}
                            data-report-finding-card
                            data-report-finding-accordion-item
                            className="border-border rounded-lg border bg-card px-3 not-last:border-b dark:bg-sidebar"
                          >
                            <AccordionTrigger
                              className="items-start py-3 font-medium hover:no-underline"
                              aria-label={
                                findingExpanded
                                  ? `Collapse finding: ${findingTitle}`
                                  : `Expand finding: ${findingTitle}`
                              }
                            >
                              <div className="flex w-full min-w-0 flex-col gap-2 pr-2 text-left">
                                <Field className="gap-1">
                                  <FieldLabel
                                    className={FINDING_ACCORDION_FIELD_LABEL_CLASS}
                                    title={findingTitle}
                                  >
                                    {findingTitle}
                                  </FieldLabel>
                                </Field>
                                {(confidenceLabel || rec.action_type) && (
                                  <Flex
                                    data-report-finding-meta=""
                                    flexWrap="nowrap"
                                    align="center"
                                    columnGap={{ base: 2, md: 3 }}
                                    rowGap={2}
                                    justify="flex-start"
                                    overflowX="auto"
                                    whiteSpace="nowrap"
                                    minW={0}
                                    pb="0"
                                    sx={{ WebkitOverflowScrolling: "touch" }}
                                    onClick={(e: React.MouseEvent) => e.stopPropagation()}
                                  >
                                    {confidenceLabel ? (
                                      <HStack spacing={2} align="center" flexShrink={0}>
                                        <FindingMetaLabelTooltip label="Confidence" />
                                        <Badge
                                          data-report-finding-meta-badge="confidence"
                                          className={FINDING_META_BADGE_CONFIDENCE_CLASS}
                                        >
                                          {confidenceLabel}
                                        </Badge>
                                      </HStack>
                                    ) : null}
                                    {rec.action_type ? (
                                      <HStack spacing={2} align="center" flexShrink={0} maxW="100%">
                                        <FindingMetaLabelTooltip label="Type" />
                                        <Badge
                                          data-report-finding-meta-badge="type"
                                          className={`${FINDING_META_BADGE_TYPE_CLASS} whitespace-nowrap`}
                                        >
                                          {String(rec.action_type).replace(/_/g, " ")}
                                        </Badge>
                                      </HStack>
                                    ) : null}
                                  </Flex>
                                )}
                                {rec.hypothesis ? (
                                  <FindingHypothesisBlock
                                    hypothesis={rec.hypothesis}
                                    subtleText={subtleText}
                                    previewClamped={!findingExpanded}
                                  />
                                ) : null}
                              </div>
                            </AccordionTrigger>
                            <AccordionContent className="text-muted-foreground pt-1 pb-4">
                              <Box id={`finding-panel-${recId}`}>
                                {rec.analysis ? (
                                  <>
                                    <Text fontSize="xs" color="#38BBD1" mb="4px" fontFamily={REPORT_PRIMARY_FONT}>
                                      Analysis
                                    </Text>
                                    <Text
                                      fontSize="sm"
                                      color={subtleText}
                                      mb="10px"
                                      lineHeight="1.5"
                                      fontFamily={REPORT_PRIMARY_FONT}
                                    >
                                      {rec.analysis}
                                    </Text>
                                  </>
                                ) : null}
                                {rec.risk ? (
                                  <>
                                    <Text fontSize="xs" color="#38BBD1" mb="4px" fontFamily={REPORT_PRIMARY_FONT}>
                                      Risk if misapplied
                                    </Text>
                                    <Text
                                      fontSize="sm"
                                      color={subtleText}
                                      mb="10px"
                                      lineHeight="1.5"
                                      fontFamily={REPORT_PRIMARY_FONT}
                                    >
                                      {rec.risk}
                                    </Text>
                                  </>
                                ) : null}
                                {rec.validation ? (
                                  <>
                                    <Text fontSize="xs" color="#38BBD1" mb="4px" fontFamily={REPORT_PRIMARY_FONT}>
                                      How you could validate
                                    </Text>
                                    <Text
                                      fontSize="sm"
                                      color={subtleText}
                                      mb="10px"
                                      lineHeight="1.5"
                                      fontFamily={REPORT_PRIMARY_FONT}
                                    >
                                      {rec.validation}
                                    </Text>
                                  </>
                                ) : null}
                                {rec.evidence_pointers.length > 0 || rec.primary_slice_id ? (
                                  <ReportEvidencePointersBlock
                                    pointers={rec.evidence_pointers}
                                    primarySliceId={rec.primary_slice_id}
                                    inputSnapshot={reportEvidenceSnapshot}
                                    analysisEvidence={report?.analysis_evidence}
                                    subtleText={subtleText}
                                    onOpenExplorerSlice={
                                      isTradeManagement && reportSectionKeys.includes("market")
                                        ? onOpenExplorerSlice
                                        : undefined
                                    }
                                    onOpenMarketContext={
                                      isEntryAnalysisReport && reportSectionKeys.includes("market")
                                        ? onOpenMarketContext
                                        : undefined
                                    }
                                  />
                                ) : null}
                              </Box>
                            </AccordionContent>
                          </AccordionItem>
                        );
                      })}
                    </Accordion>
                  </Box>
                </Box>
              ) : (
                <Box
                  id="report-overview-findings"
                  data-report-findings-rail
                  borderWidth="1px"
                  borderStyle="solid"
                  borderColor={REPORT_DETAIL_CARD_BORDER}
                  borderRadius="6px"
                  p="12px"
                >
                  <Text fontSize="sm" color={subtleText} fontFamily={REPORT_PRIMARY_FONT}>
                    No structured findings were returned for this report.
                  </Text>
                </Box>
              )}
                  </Field>
                </Box>

                {isTradeAnalysis && marketWindowOverview ? (
                  <Field className="w-full" data-report-market-backdrop="">
                    <FieldLabel className={REPORT_OVERVIEW_FIELD_LABEL_CLASS}>Market backdrop</FieldLabel>
                    <FieldDescription className={REPORT_OVERVIEW_FIELD_DESC_CLASS}>
                      Cohort market window overview from this report&apos;s analysis period.
                    </FieldDescription>
                    <Box
                      borderWidth="1px"
                      borderStyle="solid"
                      borderColor={REPORT_DETAIL_CARD_BORDER}
                      borderRadius="6px"
                      p="12px"
                      fontSize="sm"
                      color={subtleText}
                      fontFamily="mono"
                      whiteSpace="pre-wrap"
                      overflowX="auto"
                    >
                      {JSON.stringify(marketWindowOverview, null, 2)}
                    </Box>
                  </Field>
                ) : null}

                {reportOverviewMetricsBundle ? (
                  <Field className="w-full pt-4 md:pt-6" data-report-overview-metrics="">
                    <FieldLabel
                      htmlFor="report-overview-metrics"
                      className={REPORT_OVERVIEW_FIELD_LABEL_CLASS}
                    >
                      Report metrics
                    </FieldLabel>
                    <FieldDescription className={REPORT_OVERVIEW_FIELD_DESC_CLASS}>
                      Key trade statistics for this report&apos;s analysis window.
                    </FieldDescription>
                    <Box id="report-overview-metrics" w="100%">
                      <OverviewMetrics
                        embedded
                        statistics={reportOverviewMetricsBundle.statistics}
                        backendStats={reportOverviewMetricsBundle.backend}
                        comparisonType="period-over-period"
                        brokerAccountCode={brokerAccountCodeForReview ?? undefined}
                        expectancyValue={
                          (reportOverviewMetricsBundle.backend as { expectancy?: number | null })
                            ?.expectancy ??
                          reportOverviewMetricsBundle.backend.average_per_trade_pnl ??
                          null
                        }
                      />
                    </Box>
                  </Field>
                ) : null}
              </Stack>
            </CardBody>
          </Card>
            {isTradeAnalysis ? (
              <Card {...reportDetailSectionCardProps} mt={6} data-reports-trade-review-card="">
                <CardBody display="flex" flexDirection="column" pt={{ base: 4, md: 5 }} w="full">
              <ReportTradeReviewPanel
                showSectionHeader
                brokerAccountCode={brokerAccountCodeForReview}
                trades={tradesForReview}
                tradesLoading={tradesForReviewLoading}
                tradesError={fetchedTradesForReviewError}
                reportId={report.id}
                reportTimeframe={report.timeframe}
                reportStartDate={report.start_date}
                reportEndDate={report.end_date}
                reportTimezone={reportTimezoneFromPayload ?? reportingTimeZoneForTrades}
                cohortPeriod={report.cohort_period}
                inputSnapshot={report.input_snapshot}
                asOfEndMs={reportCreatedAsOfExactMs}
                defaultCandleTimeframe={candleTimeframeForReport}
                recordedTimezoneLabel={displayRecordedTimezoneWithUtc || undefined}
                linkedBacktests={linkedBacktests}
                overlayBacktestId={overlayBacktestId}
                onOverlayBacktestIdChange={setOverlayBacktestId}
                overlayEnabled={overlayEnabled}
                onOverlayEnabledChange={setOverlayEnabled}
                overlayTradeIdsLoading={overlayTradeIdsLoading}
                overlayTradeIdsError={overlayTradeIdsError}
                overlayTradeIds={overlayTradeIds}
                policyOverlay={policyOverlayForReview}
                backtestId={backtestIdForSimulatorReview}
                simulationOverlayMode={simulationOverlayModeForReview}
                backtestSimulationRows={overlayBacktestSimulationRows}
                simulatedLegs={overlaySimulatedLegs}
                uiPersistenceKey="overview-main"
              />
                </CardBody>
              </Card>
            ) : null}
            <ReportTabNotesSection
              reportId={report.id}
              tabKey="overview"
              borderColor={borderColor}
              subtleText={subtleText}
              textColor={textColor}
            />
            <ReportSectionTabNavFooter
              tabIndex={reportSectionTabIndex}
              sectionTabLabels={sectionTabLabels}
              sectionTabTitles={sectionTabTitles}
              onNavigate={navigateReportSectionFromFooter}
              borderColor={borderColor}
            />
            </Box>
            </InstrumentSetupGate>
            </TabsContent>
            ) : null}

            {reportSectionKeys.includes("market") ? (
            <TabsContent value="market" className="mt-0 data-[state=inactive]:pointer-events-none data-[state=inactive]:hidden">
            <InstrumentSetupGate
              featureLabel={gatedReportFeatureLabel}
              bypass={!gateExitRegimeDetail}
            >
          <ReportSectionTabLayout
            reportId={report.id}
            tabKey="market"
            borderColor={borderColor}
            subtleText={subtleText}
            textColor={textColor}
            footer={
              <ReportSectionTabNavFooter
                tabIndex={reportSectionKeys.indexOf("market")}
                sectionTabLabels={sectionTabLabels}
                sectionTabTitles={sectionTabTitles}
                onNavigate={navigateReportSectionFromFooter}
                borderColor={borderColor}
              />
            }
          >
            {isTradeManagement ? (
              <ManagementExplorerSection
                reportId={report.id}
                inputSnapshot={report.input_snapshot}
                textColor={textColor}
                subtleText={subtleText}
                candleTimeframe={candleTimeframeForReport}
                focusSliceId={explorerFocusSliceId}
                focusNonce={explorerFocusNonce}
                onDismissExplorerFocus={onDismissExplorerFocus}
                onPreviewExplorerSlice={onPreviewExplorerSlice}
                previewActiveKey={marketCohortPreview.activeRowKey}
                previewLoadingKey={marketCohortPreview.previewLoadingKey}
              />
            ) : (
              <ConditionAnalysisSection
                reportId={report.id}
                reportType={report.report_type}
                candleTimeframe={candleTimeframeForReport}
                inputSnapshot={reportEvidenceSnapshot}
                analysisEvidence={report.analysis_evidence}
                textColor={textColor}
                subtleText={subtleText}
                evidencePreBg={evidencePreBg}
                evidencePreBorder={evidencePreBorder}
                marketContextFocus={marketContextFocus}
                marketContextFocusNonce={marketContextFocusNonce}
                onDismissMarketContextFocus={() => setMarketContextFocus(null)}
                onPreviewConditionBucket={onPreviewConditionBucket}
                onPreviewConditionSituation={onPreviewConditionSituation}
                onPreviewConditionSlice={onPreviewConditionSlice}
                onPreviewConditionSummaryRow={onPreviewConditionSummaryRow}
                previewActiveKey={marketCohortPreview.activeRowKey}
                previewLoadingKey={marketCohortPreview.previewLoadingKey}
              />
            )}

            {marketCohortPreview.previews.map((preview) => (
              <ReportMarketCohortPreviewCard
                key={preview.rowKey}
                preview={preview}
                tradesForReview={tradesForReview}
                tradesByIdForCohortStats={tradesByIdForCohortStats}
                overlayStats={marketCohortOverlayStatsByKey[preview.rowKey]}
                onUpsertOverlayStats={onUpsertCohortOverlayStats}
                onListFilterChange={marketCohortPreview.setListFilter}
                onClear={marketCohortPreview.clearPreview}
                tradesLoading={tradesForReviewLoading}
                tradesError={fetchedTradesForReviewError}
                report={report}
                brokerAccountCode={brokerAccountCodeForReview}
                reportTimezone={reportTimezoneFromPayload ?? reportingTimeZoneForTrades}
                candleTimeframe={candleTimeframeForReport}
                recordedTimezoneLabel={displayRecordedTimezoneWithUtc || undefined}
                asOfEndMs={reportCreatedAsOfExactMs}
                requireInstrumentSetup={gateExitRegimeDetail}
              />
            ))}
          </ReportSectionTabLayout>
            </InstrumentSetupGate>
            </TabsContent>
            ) : null}

            {reportSectionKeys.includes("simulator") ? (
            <TabsContent
              value="simulator"
              className="mt-0 data-[state=inactive]:pointer-events-none data-[state=inactive]:hidden"
            >
            <InstrumentSetupGate featureLabel="Simulator" bypass={!blockReportSimulator}>
          <>
          <Card {...reportDetailSectionCardProps}>
            <CardHeader pb="0" flexDirection="column" alignItems="stretch">
              <VStack align="stretch" spacing={2} w="100%">
                <Flex align="flex-start" justify="space-between" gap={3} flexWrap="wrap" w="100%">
                  <Text
                    fontSize={{ base: "2xl", md: "3xl" }}
                    color="#38BBD1"
                    fontWeight="normal"
                    fontFamily={REPORT_PRIMARY_FONT}
                    lineHeight="1.15"
                    flex="1"
                    minW={0}
                  >
                    Simulator
                  </Text>
                  <SimulatorComparisonQuota
                    used={simulatorComparisonRunsUsed}
                    subtleText={subtleText}
                    variant="pill"
                  />
                </Flex>
                <Text fontSize="sm" color={subtleText} mt={1} fontFamily={REPORT_PRIMARY_FONT}>
                  {isTradeManagement
                    ? "Run SL/TP override rules from your sim cart on this report’s closed trades. Compare baseline vs managed exits and review per-trade stop/target outcomes."
                    : "Simulate candle-based rules on this report’s closed trades. The simulator recomputes features as of each entry and returns baseline vs filtered performance for your policy so you can compare scenarios side-by-side."}
                </Text>
              </VStack>
            </CardHeader>
            <CardBody display="flex" flexDirection="column" pt={0} w="full">
              <ExecutionRulesSimulatorPanel
                variant="report"
                scopedReportId={report.id}
                inputSnapshot={report.input_snapshot}
                prefillWindow={{ start_date: report.start_date, end_date: report.end_date, timeframe: report.timeframe }}
                reportCreatedAt={report.created_at}
                prefillStrategyId={report.strategy_id ?? null}
                hideScopeControls
                hideSavedBacktestsButton
                layout="embedded"
                hydrateSavedBacktests
                linkedBacktests={linkedBacktests}
                linkedBacktestsLoading={linkedBacktestsLoading}
                onComparisonRunsUsedChange={setSimulatorComparisonRunsUsed}
                workspaceSimulationContext={workspaceSimulationContext}
                resolveWorkspacePolicyAttach={resolveWorkspacePolicyAttach}
                onBacktestSaved={(backtestId) => {
                  void loadLinkedBacktests();
                  return onWorkspaceSimulationSaved?.(backtestId);
                }}
                onBacktestDeleted={(backtestId) => {
                  const id = backtestId.trim();
                  if (!id) return;
                  setLinkedBacktests((prev) => prev.filter((b) => b.id !== id));
                  setOverlayBacktestId((current) => {
                    if (current !== id) return current;
                    setOverlayEnabled(false);
                    return "";
                  });
                }}
                onStrategyVersionSaved={(backtestId) => {
                  void loadStrategyDetail({ selectCurrentVersion: true });
                  void onStrategyVersionSaved?.(backtestId);
                }}
                lockedPolicyRowVersion={reportPolicyRowVersion}
                lockedBrokerAccountCode={report.broker_account_code ?? ((report.input_snapshot as any)?.broker_account_code ?? null)}
                defaultCandleTimeframe={candleTimeframeForReport}
                {...(isTradeManagement
                  ? {
                      policyMode: "v2" as const,
                      tradeSideFilter: managementSnapshot.tradeSideFilter,
                      onSimulateComplete: () => void load(),
                    }
                  : { policyMode: "v1" as const })}
              />
            </CardBody>
          </Card>
          {!isTradeAnalysis ? (
            <ReportTradingPnlSection
              reportId={report.id}
              trades={tradesForReview}
              linkedBacktests={linkedBacktests}
              isTradeManagement={isTradeManagement}
              tradesLoading={tradesForReviewLoading}
              asOfEndMs={reportCreatedAsOfEndMs}
              asOfLabel={reportCreatedAsOfLabel}
            />
          ) : null}
          {!isTradeAnalysis ? (
            <Card {...reportDetailSectionCardProps} mt={6} data-reports-trade-review-card="">
              <CardBody display="flex" flexDirection="column" pt={{ base: 4, md: 5 }} w="full">
                <ReportTradeReviewPanel
                  showSectionHeader
                  requireInstrumentSetup
                  sectionDescription="Chart and trade list for this report window. Use the overlay menu to pick a saved simulation — your choice is independent of the comparison tabs above."
                  brokerAccountCode={brokerAccountCodeForReview}
                  trades={tradesForSimulatorReview}
                  tradesLoading={tradesForReviewLoading}
                  tradesError={fetchedTradesForReviewError}
                  reportId={report.id}
                  reportTimeframe={report.timeframe}
                  reportStartDate={report.start_date}
                  reportEndDate={report.end_date}
                  reportTimezone={reportTimezoneFromPayload ?? reportingTimeZoneForTrades}
                  cohortPeriod={report.cohort_period}
                  inputSnapshot={report.input_snapshot}
                  asOfEndMs={reportCreatedAsOfExactMs}
                  defaultCandleTimeframe={candleTimeframeForReport}
                  recordedTimezoneLabel={displayRecordedTimezoneWithUtc || undefined}
                  linkedBacktests={linkedBacktests}
                  overlayBacktestId={overlayBacktestId}
                  onOverlayBacktestIdChange={setOverlayBacktestId}
                  overlayEnabled={overlayEnabled}
                  onOverlayEnabledChange={setOverlayEnabled}
                  overlayTradeIdsLoading={overlayTradeIdsLoading}
                  overlayTradeIdsError={overlayTradeIdsError}
                  overlayTradeIds={overlayTradeIds}
                  policyOverlay={policyOverlayForReview}
                  backtestId={backtestIdForSimulatorReview}
                  simulationOverlayMode={simulationOverlayModeForReview}
                  backtestSimulationRows={overlayBacktestSimulationRows}
                  simulatedLegs={overlaySimulatedLegs}
                  uiPersistenceKey="simulator-main"
                />
              </CardBody>
            </Card>
          ) : null}
          {!isTradeAnalysis ? (
            <InstrumentSetupGate featureLabel="Comparison charts" bypass={!blockReportSimulator}>
              <ReportComparisonTradeReviewStack
                {...comparisonTradeReviewSharedProps}
                isTmSimulationOverlay={isTmSimulationOverlayForBacktest}
                simulationOverlayModeForReview={simulationOverlayModeForReview}
                getBacktestSimulationRows={getBacktestSimulationRows}
                getSimulatedLegs={getSimulatedLegsForBacktest}
              />
            </InstrumentSetupGate>
          ) : null}
          <ReportTabNotesSection
            reportId={report.id}
            tabKey="simulator"
            borderColor={borderColor}
            subtleText={subtleText}
            textColor={textColor}
          />
          <ReportSectionTabNavFooter
            tabIndex={reportSectionTabIndex}
            sectionTabLabels={sectionTabLabels}
            sectionTabTitles={sectionTabTitles}
            onNavigate={navigateReportSectionFromFooter}
            borderColor={borderColor}
          />
          </>
            </InstrumentSetupGate>
            </TabsContent>
            ) : null}

            {reportSectionKeys.includes("pine") ? (
            <TabsContent value="pine" className="mt-0">
          <>
          <Card {...reportDetailSectionCardProps}>
            <CardHeader pb={{ base: 3, md: 4 }}>
              <Box flex="1" minW={{ base: "100%", md: "260px" }}>
                <Text
                  fontSize={{ base: "2xl", md: "3xl" }}
                  color="#38BBD1"
                  fontWeight="normal"
                  fontFamily="'Urbanist', sans-serif"
                  lineHeight="1.15"
                >
                  Generate Pinescript
                </Text>
                <Text fontSize="sm" color={subtleText} mt={1}>
                  Turn a saved strategy version into TradingView Pinescript for this strategy. That version is the rule
                  snapshot you stored after simulating—whether from condition picks or a manual rule tree—so chart logic can
                  match what you tested and stay tied to this strategy.
                </Text>
                {report?.strategy_id ? (
                  <Flex mt={2} align="center" gap={2} flexWrap="wrap" rowGap={1}>
                    <Text fontSize="sm" color={subtleText} fontFamily="'IBM Plex Sans', sans-serif" flexShrink={0}>
                      Version assigned to Strategy:
                    </Text>
                    <ChakraBadge
                      bgGradient="linear-gradient(135deg, #38BBD1, #3EEAEC)"
                      color="white"
                      fontSize="xs"
                      fontFamily={
                        pineScriptStrategyDisplayName === "Loading…" ? "mono" : "'IBM Plex Sans', sans-serif"
                      }
                      fontWeight="medium"
                      textTransform={
                        pineScriptStrategyDisplayName === "Loading…" || pineScriptStrategyDisplayName === "Strategy"
                          ? "none"
                          : "uppercase"
                      }
                      p="3px 10px"
                      borderRadius="6px"
                      whiteSpace="normal"
                      maxW="100%"
                      lineHeight="1.35"
                    >
                      {pineScriptStrategyDisplayName}
                    </ChakraBadge>
                  </Flex>
                ) : null}
              </Box>
            </CardHeader>
            <CardBody pt={{ base: 1, md: 2 }}>
              {!report?.strategy_id ? (
                <Text color={subtleText} fontSize="sm">
                  This report isn’t linked to a strategy (`strategy_id` is missing), so Pinescript generation is unavailable.
                </Text>
              ) : strategyDetailError ? (
                <AlertAny status="error" borderRadius="6px" fontSize="sm">
                  <AlertIconAny />
                  <AlertDescriptionAny>{strategyDetailError}</AlertDescriptionAny>
                </AlertAny>
              ) : strategyDetailLoading && !strategyDetail ? (
                <HStack spacing={3}>
                  <Spinner size="sm" />
                  <Text color={subtleText}>Loading strategy…</Text>
                </HStack>
              ) : (
                <VStack align="stretch" spacing={3}>
                  <Box borderWidth="1px" borderRadius="6px" borderColor={borderColor} p={{ base: 3, md: 4 }}>
                    {!pineScript ? (
                      <Text color={subtleText} fontSize="sm" mb={3} fontFamily="'IBM Plex Sans', sans-serif">
                        Pick a strategy version below, then click Generate to build Pinescript from those saved rules.
                      </Text>
                    ) : null}
                    <Flex justify="space-between" align="flex-end" wrap="wrap" gap={3}>
                      <Box flex="1" minW={{ base: "100%", sm: "220px" }}>
                        <Text fontSize="xs" color={subtleText} textTransform="uppercase" mb={1}>
                          Strategy version
                        </Text>
                        <ConfiguratorStyleMenu
                          borderRadius="6px"
                          triggerWidth="hug"
                          currentLabel={policyVersionMenuCurrentLabel}
                          options={policyVersionMenuOptions}
                          onSelect={setSelectedPolicyVersionId}
                          isDisabled={policyVersionMenuOptions.length === 0}
                        />
                      </Box>
                      <HStack spacing={2} flexWrap="wrap" justify="flex-end" flexShrink={0}>
                        <Button
                          size="sm"
                          px="20px"
                          h="32px"
                          minH="32px"
                          py={0}
                          lineHeight="1"
                          fontSize="xs"
                          fontFamily="'IBM Plex Sans', sans-serif"
                          fontWeight="medium"
                          textTransform="uppercase"
                          borderRadius="6px"
                          bgGradient="linear-gradient(135deg, #38BBD1, #3EEAEC)"
                          color="white"
                          _hover={{ opacity: 0.9 }}
                          _active={{ opacity: 0.85 }}
                          onClick={() => void onGeneratePine()}
                          isLoading={pineLoading}
                          isDisabled={!report?.strategy_id || !selectedPolicyVersionId || pineLoading}
                          title={!report?.strategy_id ? "This report is not linked to a strategy." : ""}
                        >
                          Generate
                        </Button>
                        {pineScript ? (
                          <Button
                            size="sm"
                            px="20px"
                            h="32px"
                            minH="32px"
                            py={0}
                            lineHeight="1"
                            fontSize="xs"
                            fontFamily="'IBM Plex Sans', sans-serif"
                            fontWeight="medium"
                            textTransform="uppercase"
                            borderRadius="6px"
                            variant="outline"
                            color={subtleText}
                            borderColor={borderColor}
                            onClick={() => void copyPine()}
                          >
                            Copy code
                          </Button>
                        ) : null}
                      </HStack>
                    </Flex>
                  </Box>

                  {pineScript ? (
                    <Alert status="info" borderRadius="6px" fontSize="sm" alignItems="flex-start">
                      <AlertIcon mt="2px" />
                      <AlertDescription>
                        <Text fontWeight="semibold" mb={2} color={textColor} fontFamily="'IBM Plex Sans', sans-serif">
                          Match TradingView to your report timezone
                        </Text>
                        <Text color={subtleText} lineHeight="1.5" fontSize="sm" fontFamily="'IBM Plex Sans', sans-serif">
                          In TradingView, set the chart timezone to the same zone you use in your display preferences
                          (dashboard) and the zone used for this report’s analysis window. If they differ, session labels
                          and candle boundaries can diverge from what you tested here. Dashboard (Display preferences):{" "}
                          {displayDashboardTimezoneWithUtc ?? dashboardDisplayTimezoneIana ?? "—"} · This report:{" "}
                          {displayRecordedTimezoneWithUtc ??
                            displayRecordedTimezone ??
                            "Not recorded for this report"}
                        </Text>
                      </AlertDescription>
                    </Alert>
                  ) : null}

                  {pineError ? (
                    <AlertAny status="error" borderRadius="6px" fontSize="sm">
                      <AlertIconAny />
                      <AlertDescriptionAny>
                        {pineError}
                        {(pineCompileUnsupportedPaths.length > 0 || pineCompileUnsupportedOps.length > 0) && (
                          <Box mt={2}>
                            {pineCompileUnsupportedPaths.length > 0 ? (
                              <Box mb={2}>
                                <Text fontSize="xs" color={subtleText} textTransform="uppercase" mb={1}>
                                  Unsupported paths
                                </Text>
                                <Box as="pre" fontSize="xs" fontFamily="mono" whiteSpace="pre-wrap" m={0}>
                                  {pineCompileUnsupportedPaths.join("\n")}
                                </Box>
                              </Box>
                            ) : null}
                            {pineCompileUnsupportedOps.length > 0 ? (
                              <Box>
                                <Text fontSize="xs" color={subtleText} textTransform="uppercase" mb={1}>
                                  Unsupported ops
                                </Text>
                                <Box as="pre" fontSize="xs" fontFamily="mono" whiteSpace="pre-wrap" m={0}>
                                  {pineCompileUnsupportedOps.join("\n")}
                                </Box>
                              </Box>
                            ) : null}
                          </Box>
                        )}
                      </AlertDescriptionAny>
                    </AlertAny>
                  ) : null}

                  {pineScript ? <PineScriptCodeBlock code={pineScript} maxH="420px" /> : null}
                </VStack>
              )}
            </CardBody>
          </Card>
          <ReportTabNotesSection
            reportId={report.id}
            tabKey="pine"
            borderColor={borderColor}
            subtleText={subtleText}
            textColor={textColor}
          />
          <ReportSectionTabNavFooter
            tabIndex={reportSectionKeys.indexOf("pine")}
            sectionTabLabels={sectionTabLabels}
            sectionTabTitles={sectionTabTitles}
            onNavigate={navigateReportSectionFromFooter}
            borderColor={borderColor}
          />
          </>
            </TabsContent>
            ) : null}

            {reportSectionKeys.includes("notes") ? (
            <TabsContent value="notes" className="mt-0">
          <>
            <ReportNotesHubPanel
              reportId={report.id}
              reportType={report.report_type}
              isActive={reportSectionTab === "notes"}
              borderColor={borderColor}
              subtleText={subtleText}
              textColor={textColor}
            />
            <ReportSectionTabNavFooter
              tabIndex={reportSectionKeys.indexOf("notes")}
              sectionTabLabels={sectionTabLabels}
              sectionTabTitles={sectionTabTitles}
              onNavigate={navigateReportSectionFromFooter}
              borderColor={borderColor}
            />
          </>
            </TabsContent>
            ) : null}
          </Tabs>
          ) : null}
        </VStack>
      )}
        </>
      )}
    </Box>
  ) as any;

  return (
    <>
      {page}
      <DeleteReportsDialog
        open={deleteReportsRequest != null}
        onOpenChange={closeDeleteReportsDialog}
        request={deleteReportsRequest}
        isDeleting={deleting}
        onConfirm={() => void onDeleteReport()}
      />
    </>
  );
}

